<template>
  <div class="addFormMainTab">
    <div class="addFormMainTab__data">
      <div class="addFormMainTab__data--left">

        <!-- Parent Task -->
        <div class="addFormMainTab__data--left--item d-flex align-center w-100">
          <div class="item-container">
            <ad_filters_icons
              :icon="'arrow_top_bold'"
              class="item-container--icon"
              />
            <p class="item-container--text mb-0">Parent Task</p>
          </div>
          <div
            v-if="!isEditing.includes('editableInput-taskName')"
            class="mb-0 item-input"
            :class="{
              'hover': isHovered.includes('editableInput-taskName'),
              'item-input--empty': !assignmentForm.taskName,
              'item-input--fullfield': assignmentForm.taskName,
            }"
            style="position: relative;"
            @mouseenter="isHoveredOn('editableInput-taskName')"
            @mouseleave="isHoveredOff('editableInput-taskName')"
            @click="startEditing('editableInput-taskName')"
          >
            <p class="item-input--p mb-0">
              {{ assignmentForm.taskName ? assignmentForm.taskName : 'No Name' }}
            </p>
            <span
              @click.stop.prevent="updateAssignmentData({ field: 'taskName', data: '' })"
              class="item-input--clear"
              v-if="isHovered.includes('editableInput-taskName') && assignmentForm.taskName"
            >
              <pmdashboard_table_icons
                :icon="'pmdashboard_clear_text_field'"
                class="pmdashboard__clear-text d-block"
              />
            </span>
          </div>
          <input
            v-else
            type="text"
            ref="editableInput-taskName"
            v-model="taskNameField"
            @blur="stopEditing('editableInput-taskName')"
            @keydown.enter="stopEditing('editableInput-taskName')"
            class="hover item-input--empty item-input--field bradius-4"
          />
        </div>

        <!-- Project -->
        <div class="addFormMainTab__data--left--item d-flex align-center w-100">
          <div class="item-container" style="margin-left: 26px; width: 144px;">
            <!-- <pmdashboard_table_icons
              :icon="'pmdashboard_book--error'"
              class="item-container--icon"
              v-if="mainTabData.relatedProject?.name === 'Empty'"
              /> -->
            <ad_form_icons
              :icon="'pmdashboard_book'"
              class="item-container--icon"
              />
            <p class="item-container--text mb-0"
              :class="{ 'error-color': assignmentForm.relatedProject?.name === 'Empty', 
                'shake': assignmentForm.relatedProject?.name === 'Empty' }">Project</p>
          </div>
          <div class="mb-0 item-input-p0" :class="{
              'hover': isHovered.includes('editableInput-relatedProject'),
              'item-input--empty': assignmentForm.relatedProject?.name === 'Empty',
              'item-input--fullfield': assignmentForm.relatedProject?.name !== 'Empty'
            }"
            @mouseover="isHoveredOn('editableInput-relatedProject')"
            @mouseleave="isHoveredOff('editableInput-relatedProject')">
            <div class="addFormMainTab__task--content-left--text mb-0 d-flex align-center w-100">
              <p
                v-if="assignmentForm.relatedProject?.name === 'Empty' && !relatedProjectMenu"
                class="mb-0 item-input--p"
                id="editableInput-relatedProject"
                :class="{
                  'hover': isHovered.includes('editableInput-relatedProject'),
                  'item-input--empty': assignmentForm.relatedProject?.name === 'Empty',
                  'item-input--fullfield': assignmentForm.relatedProject?.name !== 'Empty'
                }"
                @mouseover="isHoveredOn('editableInput-relatedProject')"
                @mouseleave="isHoveredOff('editableInput-relatedProject')"
                @click="relatedProjectMenu = !relatedProjectMenu"
              >
                Empty
              </p>
              <div class="addFormMainTab__task--content-left--text mb-0 d-flex align-center additional-hover p-relative"
                v-if="!relatedProjectMenu && assignmentForm.relatedProject?.name !== 'Empty'"
                @click="relaunchRelatedProject">
                <div class="user-status-name item-input">
                  <p class="user-status-name-text mb-0 ml-2" id="editableInput-relatedProject">{{ assignmentForm.relatedProject?.name }}</p>
                  <span v-if="assignmentForm.relatedProject?.name !== 'Empty' && isHovered.includes('editableInput-relatedProject')"
                    @click="clearRelatedProject()"
                    class="item-input--clear"
                  >
                    <pmdashboard_table_icons
                      :icon="'pmdashboard_clear_text_field'"
                      class="pmdashboard__clear-text d-block"
                    />
                  </span>
                </div>
              </div>
              <v-autocomplete
                v-show="relatedProjectMenu && assignmentForm.relatedProject?.name === 'Empty'"
                :items="projectsList"
                ref="relatedProjectAutocomplete" 
                item-value="id"
                item-text="projectName"
                return-object
                hide-no-data
                hide-details
                id="editableInput-relatedProject"
                class="mt-0 pt-0 empty-p-field"
                autofocus
                :menu-props="{ openOnFocus: true, closeOnContentClick: true }"
              >
                <template v-slot:item="{ item }">
                  <v-list-item class="additional-hover">
                    <v-list-item-content @click="handleRelatedProjectUpdate(item)">
                      <v-list-item-title>
                        {{ item?.projectName }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </div>
          </div>
        </div>

        <!-- Client Requester -->
        <div class="addFormMainTab__data--left--item d-flex align-center w-100">
          <div class="item-container" style="margin-left: 24px; width: 146px;">
            <pmdashboard_table_icons
              :icon="'pmdashboard_account'"
              class="item-container--icon"
              style="width: 24px !important; height: 24px !important;"
              />
            <p class="item-container--text mb-0"
              :class="{ 'error-color': assignmentForm.clientRequester.user.firstName === 'Empty',
                'shake': assignmentForm.clientRequester.user.firstName === 'Empty'
              }">
              Client Req.
            </p>
          </div>
          <div class="mb-0 item-input-p0" :class="{
              'hover': isHovered.includes('editableInput-clientRequester'),
              'item-input--empty': assignmentForm.clientRequester.user.firstName === 'Empty',
              'item-input--fullfield': assignmentForm.clientRequester.user.firstName !== 'Empty'
            }"
            @mouseover="isHoveredOn('editableInput-clientRequester')"
            @mouseleave="isHoveredOff('editableInput-clientRequester')">
            <div class="addFormMainTab__task--content-left--text mb-0 d-flex align-center w-100">
              <p
                v-if="assignmentForm.clientRequester.user.firstName === 'Empty' && !clientRequesterMenu"
                class="mb-0 item-input--p"
                id="editableInput-clientRequester"
                :class="{
                  'hover': isHovered.includes('editableInput-clientRequester'),
                  'item-input--empty': assignmentForm.clientRequester.user.firstName === 'Empty',
                  'item-input--fullfield': assignmentForm.clientRequester.user.firstName !== 'Empty'
                }"
                @mouseover="isHoveredOn('editableInput-clientRequester')"
                @mouseleave="isHoveredOff('editableInput-clientRequester')"
                @click="clientRequesterMenu = !clientRequesterMenu"
              >
                Empty (select project first)
              </p>
              <div class="addFormMainTab__task--content-left--text mb-0 d-flex align-center additional-hover p-relative"
                v-if="!clientRequesterMenu && assignmentForm.clientRequester.user.firstName !== 'Empty'"
                @click="relaunchClientRequester">
                <div class="user-status-name item-input">
                  <p class="user-status-name-text mb-0 ml-2" id="editableInput-clientRequester">{{ assignmentForm.clientRequester.user?.firstName + " " + assignmentForm.clientRequester.user?.lastName }}</p>
                  <span
                    v-if="assignmentForm.clientRequester.user.firstName !== 'Empty' && isHovered.includes('editableInput-clientRequester')"
                    @click="clearClientRequester()"
                    class="item-input--clear"
                  >
                    <pmdashboard_table_icons
                      :icon="'pmdashboard_clear_text_field'"
                      class="pmdashboard__clear-text d-block"
                    />
                  </span>
                </div>
              </div>
              <v-autocomplete
                v-show="clientRequesterMenu && assignmentForm.clientRequester.user.firstName === 'Empty'"
                :items="clientRequesterList"
                ref="clientRequesterAutocomplete" 
                item-value="id"
                item-text="name"
                return-object
                hide-no-data
                hide-details
                id="editableInput-clientRequester"
                class="mt-0 pt-0 empty-p-field"
                autofocus
                :menu-props="{ openOnFocus: true, closeOnContentClick: true }"
              >
                <template v-slot:item="{ item }">
                  <v-list-item class="additional-hover">
                    <v-list-item-content @click="handleClientRequesterUpdate(item)">
                      <v-list-item-title>
                        {{ item.user.firstName + " " + item.user.lastName }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </div>
          </div>
        </div>

        <!-- Pay Period -->
        <div class="addFormMainTab__data--left--item d-flex align-center w-100" >
          <div class="item-container" style="margin-left: 26px; width: 144px;">
            <v-icon class="item-container--icon" >
              mdi-cash
            </v-icon>
            <p class="item-container--text mb-0"
              :class="{ 'error-color': !assignmentForm.payPeriod,
                'shake': !assignmentForm.payPeriod
              }">
              Pay Period
            </p>
          </div>
          <div class="addFormMainTab__task--content-left--text mb-0 d-flex align-center additional-hover p-relative">
            <div class="user-status-name">
              <v-menu
                v-model="payPeriodMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <p
                    class="user-status-name-text mb-0 ml-0"
                    :class="{
                      'hover': isHovered.includes('editableInput-payPeriod'),
                      'item-input--empty': !assignmentForm.payPeriod,
                      'item-input--fullfield': assignmentForm.payPeriod,
                    }"
                    @mouseover="isHoveredOn('editableInput-payPeriod')"
                    @mouseout="isHoveredOff('editableInput-payPeriod')"
                    @click="payPeriodMenu = true"
                  >
                    {{ assignmentForm.payPeriod ? formattedPayPeriod(assignmentForm.payPeriod) : 'Empty' }}
                  </p>
                </template>
                
                <v-card>
                  <v-date-picker
                    type="month"
                    v-model="payPeriodField"
                    @input="onPayPeriodPicker"
                  ></v-date-picker>
                </v-card>
                
              </v-menu>
            </div>
          </div>
        </div>

        <!-- Purchase Order -->
         <div class="addFormMainTab__data--left--item d-flex align-center w-100">
          <div class="item-container">
            <ad_form_icons
              :icon="'adashboard_PO'"
              class="item-container--icon"
              />
            <p class="item-container--text mb-0"
              :class="{ 'error-color': !assignmentForm.purchaseOrder,
                'shake': !assignmentForm.purchaseOrder
              }">
              Purchase Order
            </p>
          </div>
          <div class="mb-0 item-input-p0" :class="{
              'hover': isHovered.includes('editableInput-purchaseOrder'),
              'item-input--empty': !assignmentForm.purchaseOrder,
              'item-input--fullfield': assignmentForm.purchaseOrder
            }"
            @mouseover="isHoveredOn('editableInput-purchaseOrder')"
            @mouseleave="isHoveredOff('editableInput-purchaseOrder')">
            <div class="addFormMainTab__task--content-left--text mb-0 d-flex align-center w-100">
              <p
                v-if="!assignmentForm.purchaseOrder && !purchaseOrderMenu"
                class="mb-0 item-input--p"
                id="editableInput-purchaseOrder"
                :class="{
                  'hover': isHovered.includes('editableInput-purchaseOrder'),
                  'item-input--empty': !assignmentForm.purchaseOrder,
                  'item-input--fullfield': assignmentForm.purchaseOrder
                }"
                @mouseover="isHoveredOn('editableInput-purchaseOrder')"
                @mouseleave="isHoveredOff('editableInput-purchaseOrder')"
                @click="relaunchPurchaseOrder"
              >
                Empty (select project first)
              </p>
              <div class="addFormMainTab__task--content-left--text mb-0 d-flex align-center additional-hover p-relative"
                v-if="!purchaseOrderMenu && assignmentForm.purchaseOrder"
                @click="relaunchPurchaseOrder">
                <div class="user-status-name item-input">
                  <p class="user-status-name-text mb-0 ml-2" id="editableInput-purchaseOrder">{{ assignmentForm.purchaseOrder.purchaseOrderNumber }}</p>
                  <span
                    v-if="assignmentForm.purchaseOrder && isHovered.includes('editableInput-purchaseOrder')"
                    @click="clearPOField()"
                    class="item-input--clear"
                  >
                    <pmdashboard_table_icons
                      :icon="'pmdashboard_clear_text_field'"
                      class="pmdashboard__clear-text d-block"
                    />
                  </span>
                </div>
              </div>
              <v-autocomplete
                v-show="purchaseOrderMenu && !assignmentForm.purchaseOrder"
                :items="assignmentForm.relatedProject.purchaseOrders"
                ref="purchaseOrderAutocomplete" 
                item-value="id"
                item-text="purchaseOrderNumber"
                return-object
                hide-no-data
                hide-details
                id="editableInput-purchaseOrder"
                class="mt-0 pt-0 empty-p-field"
                autofocus
                :menu-props="{ openOnFocus: true, closeOnContentClick: true }"
              >
                <template v-slot:item="{ item }">
                  <v-list-item class="additional-hover">
                    <v-list-item-content @click="handleClientPOUpdate(item)">
                      <v-list-item-title>
                        {{ item.purchaseOrderNumber }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </div>
          </div>
        </div>

        <!-- Status -->
        <div class="addFormMainTab__data--left--item d-flex align-center w-100">
          <div class="item-container">
            <pmdashboard_table_icons
              :icon="'pmdashboard_status'"
              class="item-container--icon"
              />
            <p class="item-container--text mb-0">Status</p>
          </div>
          <div class="mb-0 item-input-p0">
            <v-menu offset-y :close-on-content-click="true">
              <template v-slot:activator="{ on, attrs }">
                <div
                    class="mb-0 task--title bradius-4"
                    :class="{
                      'hover': isHovered.includes('editableInput-taskStatus'),
                      'item-input--empty': !assignmentForm.status,
                      'item-input--fullfield': assignmentForm.status,
                    }"
                    style="position: relative;"
                    @mouseenter="isHoveredOn('editableInput-taskStatus')"
                    @mouseleave="isHoveredOff('editableInput-taskStatus')"
                    @click="startEditing('editableInput-taskStatus')"
                    v-bind="attrs"
                    v-on="on"
                  >
                <v-chip
                  class="ma-0 addFormMainTab__status--chip"
                  :color="statusColor"
                  label
                >
                  {{ assignmentForm.status }}
                </v-chip>
              </div>
              </template>

              <!-- Dropdown Menu with Subheaders -->
              <v-list>
                <!-- INITIATION -->
                <v-subheader>INITIATION</v-subheader>
                <v-list-item
                  v-for="item in statusOptions['initiation']"
                  :key="item.text"
                  @click="updateStatus(item)"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon left :color="item.color">{{ item.icon }}</v-icon>
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <!-- IN PROGRESS -->
                <v-subheader>IN PROGRESS</v-subheader>
                <v-list-item
                  v-for="item in statusOptions['inProgress']"
                  :key="item.text"
                  @click="updateStatus(item)"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon left :color="item.color">{{ item.icon }}</v-icon>
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <!-- BLOCKED -->
                <v-subheader>BLOCKED</v-subheader>
                <v-list-item
                  v-for="item in statusOptions['blocked']"
                  :key="item.text"
                  @click="updateStatus(item)"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon left :color="item.color">{{ item.icon }}</v-icon>
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <!-- PRE-DELIVERY -->
                <v-subheader>PRE-DELIVERY</v-subheader>
                <v-list-item
                  v-for="item in statusOptions['preDelivery']"
                  :key="item.text"
                  @click="updateStatus(item)"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon left :color="item.color">{{ item.icon }}</v-icon>
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <!-- FINISHED -->
                <v-subheader>FINISHED</v-subheader>
                <v-list-item
                  v-for="item in statusOptions['finished']"
                  :key="item.text"
                  @click="updateStatus(item)"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon left :color="item.color">{{ item.icon }}</v-icon>
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>

        <!-- Billed -->
        <div class="addFormMainTab__data--left--item d-flex align-center w-100">
          <div class="item-container">
            <pmdashboard_table_icons
              :icon="'pmdashboard_billed'"
              class="item-container--icon"
              />
            <p class="item-container--text mb-0">Billed</p>
          </div>
          <div class="mb-0 item-input-p0">
            <div class="addFormMainTab__task--content-left--text mb-0 d-flex align-center w-100"
              :class="{
                'hover': isHovered.includes('editableInput-billed'),
                }"
                @mouseover="isHoveredOn('editableInput-billed')"
                @mouseleave="isHoveredOff('editableInput-billed')"
                @click="toggleIsBilled()">
              <v-checkbox
                class="mt-0 pt-0 ml-1"
                hide-details="true"
                :input-value="assignmentForm.isBilled"
              ></v-checkbox>
            </div>
          </div>
        </div>

        <!-- Project Manager-->
        <div class="addFormMainTab__data--left--item d-flex align-center w-100">
          <div class="item-container">
            <pmdashboard_table_icons
              :icon="'pmdashboard_account'"
              class="item-container--icon mr-3"
            />
            <p class="item-container--text mb-0">PM</p>
          </div>
          <div class="mb-0 item-input-p0">
            <div class="pa-0 bradius-4 w-100" :class="{
                'hover': isHovered.includes('editableInput-projectManager'),
                'item-input--empty': !assignmentForm.projectManager?.name,
                'item-input--fullfield': assignmentForm.projectManager?.name
              }"
              @mouseover="isHoveredOn('editableInput-projectManager')"
              @mouseleave="isHoveredOff('editableInput-projectManager')">
              <div class="pmdashboard__task--content-left--text mb-0 d-flex align-center">
                <p
                  v-if="!projectManagerMenu && !assignmentForm.projectManager"
                  class="mb-0 item-input--p"
                  id="editableInput-projectManager"
                  :class="{
                    'hover': isHovered.includes('editableInput-projectManager'),
                    'item-input--empty': !assignmentForm.projectManager?.name,
                    'item-input--fullfield': assignmentForm.projectManager?.name
                  }"
                  @mouseover="isHoveredOn('editableInput-projectManager')"
                  @mouseleave="isHoveredOff('editableInput-projectManager')"
                  @click="projectManagerMenu = !projectManagerMenu"
                >
                  Empty
                </p>
                <div class="addFormMainTab__task--content-left--text mb-0 d-flex align-center additional-hover p-relative"
                  v-if="!projectManagerMenu && assignmentForm.projectManager"
                  @click="relaunchPMMenu">
                  <div class="user-status-name item-input">
                    <p class="user-status-name-initials mb-0"
                      id="editableInput-projectManager"
                      :style="{ 'background-color': assignmentForm.projectManager?.initials && getColorForInitials(assignmentForm.projectManager?.initials, assignmentForm.projectManager?.name) }">
                      {{ assignmentForm.projectManager?.initials }}
                    </p>
                    <p class="user-status-name-text mb-0 ml-2" id="editableInput-projectManager">{{ assignmentForm.projectManager?.name }}</p>
                    <span
                      v-if="assignmentForm.projectManager && isHovered.includes('editableInput-projectManager')"
                      @click.prevent="updateAssignmentData({ field: 'projectManager', data: null })"
                      class="item-input--clear"
                    >
                      <pmdashboard_table_icons
                        :icon="'pmdashboard_clear_text_field'"
                        class="pmdashboard__clear-text d-block"
                      />
                    </span>
                  </div>
                </div>
                <v-autocomplete
                  v-show="projectManagerMenu && !assignmentForm.projectManager"
                  v-model="projectManagerField"
                  :items="pmList"
                  ref="pmAutocomplete" 
                  item-value="id"
                  item-text="name"
                  return-object
                  @change="handlePMUpdate"
                  hide-no-data
                  hide-details
                  id="editableInput-projectManager"
                  class="mt-0 pt-0 empty-p-field"
                  style="width: 300px;"
                  autofocus
                  :menu-props="{ openOnFocus: true, closeOnContentClick: true }"
                >
                  <template v-slot:item="{ item }">
                    <v-list-item class="additional-hover">
                      <v-list-item-content @click="handlePMUpdate(item)" class="py-2 d-flex justify-space-between align-center">
                        <v-list-item-title class="d-flex align-center">
                          <v-chip
                            class="mr-2 dropdown-initials-chip"
                            :color="getColorForInitials(item?.initials, item?.name)"
                            text-color="white"
                          >
                            {{ item?.initials }}
                          </v-chip>
                          {{ item?.name }}
                          <v-icon v-if="item?.name === temporaryUserStorage?.name"
                            class="ml-auto"
                            style="font-size: 20px;
                              font-weight: 300;
                              margin-bottom: 3px;"
                            right>
                            mdi-check
                          </v-icon>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="addFormMainTab__data--right">

        <!-- Priority -->
         <div class="addFormMainTab__data--left--item d-flex align-center w-100">
          <div class="item-container">
            <pmdashboard_table_icons
              :icon="'pmdashboard_priority_flag'"
              class="item-container--icon mr-3"
              />
            <p class="item-container--text mb-0">Priority 
              <span style="font-size: 14px; font-weight: 300; font-style: italic">(opt.)</span>
            </p>
          </div>
          <div class="mb-0 item-input-p0">
            <div class="pa-0 bradius-4 w-100">
              <v-menu
                v-model="priorityMenu"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <div 
                    class="mb-0 item-input--p relative"
                    :class="{
                      'hover': isHovered.includes('editableInput-priority'),
                      'item-input--empty': !assignmentForm.priority,
                      'item-input--fullfield': assignmentForm.priority
                    }"
                      @click="priorityMenu = !priorityMenu"
                    @mouseover="isHoveredOn('editableInput-priority')"
                    @mouseleave="isHoveredOff('editableInput-priority')">
                    <p class="mb-0 item-input--p" 
                      v-bind="attrs"
                      v-on="on">
                      <v-icon v-if="assignmentForm.priority === 'High'" left color="#B13A41" style="width:12px; height: 8px;">mdi-menu-up</v-icon>
                      <v-icon v-else-if="assignmentForm.priority === 'Medium'" 
                        left
                        class="custom-icon"
                        color="#CF940A" 
                        style="width:8px; height: 8px; margin-right: 10px; margin-left: 2px;">
                        mdi-drag-horizontal-variant
                      </v-icon>
                      <v-icon v-else-if="assignmentForm.priority === 'Low'" left color="#4466FF" style="width:12px; height: 8px;">mdi-menu-down</v-icon>
                      {{ assignmentForm.priority ? assignmentForm.priority : 'Empty' }}
                    </p>
                    <span
                      v-if="assignmentForm.priority && isHovered.includes('editableInput-priority')"
                      @click="updateAssignmentData({ field: 'priority', data: null })"
                      class="item-input--clear"
                    >
                      <pmdashboard_table_icons
                        :icon="'pmdashboard_clear_text_field'"
                        class="pmdashboard__clear-text d-block"
                      />
                    </span>
                  </div>
                </template>
                <v-list style="max-height: 300px; overflow-y: auto;">
                  <v-list-item @click="handlePriorityUpdate('High')">
                    <v-list-item-title>
                      <v-icon left color="#B13A41" style="width:12px; height: 8px;">mdi-menu-up</v-icon>
                      High
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="handlePriorityUpdate('Medium')">
                    <v-list-item-title>
                      <v-icon
                        left
                        class="custom-icon"
                        color="#CF940A" 
                        style="width:8px; height: 8px; margin-right: 14px; margin-left: -2px;">
                        mdi-drag-horizontal-variant
                      </v-icon>
                      Medium
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="handlePriorityUpdate('Low')">
                    <v-list-item-title>
                      <v-icon left color="#4466FF" style="width:12px; height: 8px;">mdi-menu-down</v-icon>
                      Low
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </div>

        <!-- File Location -->
         <div class="addFormMainTab__data--left--item d-flex align-center w-100">
          <div class="item-container">
            <pmdashboard_table_icons
              :icon="'pmdashboard_fileLocation'"
              class="item-container--icon mr-3"
              />
            <p class="item-container--text mb-0">
              File Location
            </p>
          </div>
          <div class="mb-0 item-input-p0" :class="{
              'hover': isHovered.includes('editableInput-fileLocation'),
              'item-input--empty': !assignmentForm.fileLocation,
              'item-input--fullfield': assignmentForm.fileLocation
            }"
            @mouseover="isHoveredOn('editableInput-fileLocation')"
            @mouseleave="isHoveredOff('editableInput-fileLocation')">
            <div class="addFormMainTab__task--content-left--text mb-0 d-flex align-center w-100"
              @click="relaunchFileLocation">
              <p
                v-if="!assignmentForm.fileLocation && !fileLocationMenu"
                class="mb-0 bradius-4 w-100"
                id="editableInput-fileLocation"
                :class="{
                  'hover': isHovered.includes('editableInput-fileLocation'),
                  'item-input--empty': !assignmentForm.fileLocation,
                  'item-input--fullfield': assignmentForm.fileLocation
                }"
                @mouseover="isHoveredOn('editableInput-fileLocation')"
                @mouseleave="isHoveredOff('editableInput-fileLocation')"
                @click="fileLocationMenu = !fileLocationMenu"
              >
                {{ assignmentForm.fileLocation ? assignmentForm.fileLocation.label : "Empty" }}
              </p>
              <div class="addFormMainTab__task--content-left--text mb-0 d-flex align-center w-100 relative"
                v-if="!fileLocationMenu && assignmentForm.fileLocation"
                @click="relaunchFileLocation">
                <div class="mb-0 item-input--p">
                  <p class="user-status-name-text mb-0 ml-2" id="editableInput-fileLocation">
                    <a target="_blank" :href="fileLocationOptions.find(opt => opt.label === assignmentForm.fileLocation)?.link">{{ fileLocationOptions.find(opt => opt.label === assignmentForm.fileLocation)?.label }}</a>
                  </p>
                  <span
                    v-if="assignmentForm.fileLocation && isHovered.includes('editableInput-fileLocation')"
                    @click="clearFileLocation()"
                    class="item-input--clear"
                  >
                    <pmdashboard_table_icons
                      :icon="'pmdashboard_clear_text_field'"
                      class="pmdashboard__clear-text d-block"
                    />
                  </span>
                </div>
              </div>
              <v-autocomplete
                v-show="fileLocationMenu && !assignmentForm.fileLocation"
                :items="fileLocationOptions"
                ref="fileLocationAutocomplete"
                item-text="label"
                return-object
                hide-no-data
                hide-details
                id="editableInput-fileLocation"
                class="mt-0 pt-0 empty-p-field"
                autofocus
                :menu-props="{ openOnFocus: true, closeOnContentClick: true }"
              >
                <template v-slot:item="{ item }">
                  <v-list-item class="additional-hover">
                    <v-list-item-content @click="handleFileLocationUpdate(item)">
                      <v-list-item-title>
                        {{ item?.label }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </div>
          </div>
        </div>

        <!-- Assignment Detail — the description the dashboard table and the
        Slack notification show. Distinct from the Assignment Title above. -->
        <div class="addFormMainTab__data--left--item d-flex align-center w-100">
          <div class="item-container">
            <ad_form_icons
              :icon="'pmdashboard_book'"
              class="item-container--icon"
              />
            <p class="item-container--text mb-0">Assignment Detail</p>
          </div>
          <div
            v-if="!isEditing.includes('editableInput-assignmentDetail')"
            class="mb-0 item-input"
            :class="{
              'hover': isHovered.includes('editableInput-assignmentDetail'),
              'item-input--empty': !assignmentForm.assignmentDetail,
              'item-input--fullfield': assignmentForm.assignmentDetail,
            }"
            style="position: relative;"
            @mouseenter="isHoveredOn('editableInput-assignmentDetail')"
            @mouseleave="isHoveredOff('editableInput-assignmentDetail')"
            @click="startEditing('editableInput-assignmentDetail')"
          >
            <p class="item-input--p mb-0">
              {{ assignmentForm.assignmentDetail ? assignmentForm.assignmentDetail : 'Empty' }}
            </p>
            <span
              @click.stop.prevent="updateAssignmentData({ field: 'assignmentDetail', data: '' })"
              class="item-input--clear"
              v-if="isHovered.includes('editableInput-assignmentDetail') && assignmentForm.assignmentDetail"
            >
              <pmdashboard_table_icons
                :icon="'pmdashboard_clear_text_field'"
                class="pmdashboard__clear-text d-block"
              />
            </span>
          </div>
          <input
            v-else
            type="text"
            ref="editableInput-assignmentDetail"
            v-model="assignmentDetailField"
            @blur="stopEditing('editableInput-assignmentDetail')"
            @keydown.enter="stopEditing('editableInput-assignmentDetail')"
            class="hover item-input--empty item-input--field bradius-4"
          />
        </div>

        <!-- Email Subject Line -->
        <div class="addFormMainTab__data--left--item d-flex align-center w-100">
          <div class="item-container">
            <ad_form_icons
              :icon="'email_subject_line'"
              class="item-container--icon"
              />
            <p class="item-container--text mb-0">Email Subject Line</p>
          </div>
          <div
            v-if="!isEditing.includes('editableInput-emailSubjectLine')"
            class="mb-0 item-input"
            :class="{
              'hover': isHovered.includes('editableInput-emailSubjectLine'),
              'item-input--empty': !assignmentForm.emailSubjectLine,
              'item-input--fullfield': assignmentForm.emailSubjectLine,
            }"
            style="position: relative;"
            @mouseenter="isHoveredOn('editableInput-emailSubjectLine')"
            @mouseleave="isHoveredOff('editableInput-emailSubjectLine')"
            @click="startEditing('editableInput-emailSubjectLine')"
          >
            <p class="item-input--p mb-0">
              {{ assignmentForm.emailSubjectLine ? assignmentForm.emailSubjectLine : 'No Name' }}
            </p>
            <span
              @click.stop.prevent="updateAssignmentData({ field: 'emailSubjectLine', data: '' })"
              class="item-input--clear"
              v-if="isHovered.includes('editableInput-emailSubjectLine') && assignmentForm.emailSubjectLine"
            >
              <pmdashboard_table_icons
                :icon="'pmdashboard_clear_text_field'"
                class="pmdashboard__clear-text d-block"
              />
            </span>
          </div>
          <input
            v-else
            type="text"
            ref="editableInput-emailSubjectLine"
            v-model="emailSubjectLineField"
            @blur="stopEditing('editableInput-emailSubjectLine')"
            @keydown.enter="stopEditing('editableInput-emailSubjectLine')"
            class="hover item-input--empty item-input--field bradius-4"
          />
        </div>

        <!-- Media Type -->
        <div class="addFormMainTab__data--left--item d-flex align-center w-100">
          <div class="item-container">
            <ad_form_icons
              :icon="'media_type'"
              class="item-container--icon"
              />
            <p class="item-container--text mb-0">Media Type</p>
          </div>
          <div class="mb-0 item-input-p0" :class="{
              'hover': isHovered.includes('editableInput-mediaType'),
              'item-input--empty': !assignmentForm.mediaType,
              'item-input--fullfield': assignmentForm.mediaType
            }"
            @mouseover="isHoveredOn('editableInput-mediaType')"
            @mouseleave="isHoveredOff('editableInput-mediaType')">
            <div class="addFormMainTab__task--content-left--text mb-0 d-flex align-center w-100">
              <p
                v-if="!assignmentForm.mediaType && !mediaTypeMenu"
                class="mb-0 item-input--p"
                id="editableInput-mediaType"
                :class="{
                  'hover': isHovered.includes('editableInput-mediaType'),
                  'item-input--empty': !assignmentForm.mediaType,
                  'item-input--fullfield': assignmentForm.mediaType
                }"
                @mouseover="isHoveredOn('editableInput-mediaType')"
                @mouseleave="isHoveredOff('editableInput-mediaType')"
                @click="mediaTypeMenu = !mediaTypeMenu"
              >
                Empty
              </p>
              <div class="addFormMainTab__task--content-left--text w-100 mb-0 d-flex align-center additional-hover relative"
                v-if="!mediaTypeMenu && assignmentForm.mediaType"
                @click="relaunchMediaType">
                <div class="mb-0 item-input--p w-100">
                  <p class="user-status-name-text mb-0 ml-2" id="editableInput-mediaType">{{ assignmentForm.mediaType }}</p>
                  <span v-if="assignmentForm.mediaType && isHovered.includes('editableInput-mediaType')"
                    @click="updateAssignmentData({ field: 'mediaType', data: null })"
                    class="item-input--clear"
                    style="position: absolute; "
                  >
                    <pmdashboard_table_icons
                      :icon="'pmdashboard_clear_text_field'"
                      class="pmdashboard__clear-text d-block"
                    />
                  </span>
                </div>
              </div>
              <v-autocomplete
                v-show="mediaTypeMenu && !assignmentForm.mediaType"
                :items="mediaTypeOptions"
                ref="mediaTypeAutocomplete" 
                hide-no-data
                hide-details
                id="editableInput-mediaType"
                class="mt-0 pt-0 empty-p-field"
                autofocus
                :menu-props="{ openOnFocus: true, closeOnContentClick: true }"
              >
                <template v-slot:item="{ item }">
                  <v-list-item class="additional-hover">
                    <v-list-item-content @click="setMediaType(item)">
                      <v-list-item-title>
                        {{ item }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </div>
          </div>
        </div>

        <!-- Keyword -->
        <div class="addFormMainTab__data--left--item d-flex align-center w-100">
          <div class="item-container">
            <ad_form_icons
              :icon="'keyword'"
              class="item-container--icon"
              />
            <p class="item-container--text mb-0">Keyword</p>
          </div>
          <div class="mb-0 item-input-p0" :class="{
              'hover': isHovered.includes('editableInput-keyword'),
              'item-input--empty': !assignmentForm.keyword,
              'item-input--fullfield': assignmentForm.keyword
            }"
            @mouseover="isHoveredOn('editableInput-keyword')"
            @mouseleave="isHoveredOff('editableInput-keyword')">
            <div class="addFormMainTab__task--content-left--text mb-0 d-flex align-center w-100">
              <p
                v-if="!assignmentForm.keyword && !keywordMenu"
                class="mb-0 item-input--p"
                id="editableInput-keyword"
                :class="{
                  'hover': isHovered.includes('editableInput-keyword'),
                  'item-input--empty': !assignmentForm.keyword,
                  'item-input--fullfield': assignmentForm.keyword
                }"
                @mouseover="isHoveredOn('editableInput-keyword')"
                @mouseleave="isHoveredOff('editableInput-keyword')"
                @click="keywordMenu = !keywordMenu"
              >
                Empty
              </p>
              <div class="addFormMainTab__task--content-left--text w-100 mb-0 d-flex align-center additional-hover relative"
                v-if="!keywordMenu && assignmentForm.keyword"
                @click="relaunchKeyword">
                <div class="mb-0 item-input--p w-100">
                  <p class="user-status-name-text mb-0 ml-2" id="editableInput-keyword">{{ assignmentForm.keyword }}</p>
                  <span v-if="assignmentForm.keyword && isHovered.includes('editableInput-keyword')"
                    @click="updateAssignmentData({ field: 'keyword', data: null })"
                    class="item-input--clear"
                    style="position: absolute; "
                  >
                    <pmdashboard_table_icons
                      :icon="'pmdashboard_clear_text_field'"
                      class="pmdashboard__clear-text d-block"
                    />
                  </span>
                </div>
              </div>
              <v-autocomplete
                v-show="keywordMenu && !assignmentForm.keyword"
                :items="keywordOptions"
                ref="keywordAutocomplete" 
                hide-no-data
                hide-details
                id="editableInput-keyword"
                class="mt-0 pt-0 empty-p-field"
                autofocus
                :menu-props="{ openOnFocus: true, closeOnContentClick: true }"
              >
                <template v-slot:item="{ item }">
                  <v-list-item class="additional-hover">
                    <v-list-item-content @click="setKeyword(item)">
                      <v-list-item-title>
                        {{ item }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </div>
          </div>
        </div>

        <!-- Genre -->
        <div class="addFormMainTab__data--left--item d-flex align-center w-100">
          <div class="item-container">
            <ad_form_icons
              :icon="'genre'"
              class="item-container--icon"
              />
            <p class="item-container--text mb-0">Genre</p>
          </div>
          <div
            v-if="!isEditing.includes('editableInput-genre')"
            class="mb-0 item-input"
            :class="{
              'hover': isHovered.includes('editableInput-genre'),
              'item-input--empty': !assignmentForm.genre,
              'item-input--fullfield': assignmentForm.genre,
            }"
            style="position: relative;"
            @mouseenter="isHoveredOn('editableInput-genre')"
            @mouseleave="isHoveredOff('editableInput-genre')"
            @click="startEditing('editableInput-genre')"
          >
            <p class="item-input--p mb-0">
              {{ assignmentForm.genre ? assignmentForm.genre : 'Empty' }}
            </p>
            <span
              @click.stop.prevent="updateAssignmentData({ field: 'genre', data: '' })"
              class="item-input--clear"
              v-if="isHovered.includes('editableInput-genre') && assignmentForm.genre"
            >
              <pmdashboard_table_icons
                :icon="'pmdashboard_clear_text_field'"
                class="pmdashboard__clear-text d-block"
              />
            </span>
          </div>
          <input
            v-else
            type="text"
            ref="editableInput-genre"
            v-model="genreField"
            @blur="stopEditing('editableInput-genre')"
            @keydown.enter="stopEditing('editableInput-genre')"
            class="hover item-input--empty item-input--field bradius-4"
          />
        </div>

        <!-- Word Count -->
        <div class="addFormMainTab__data--left--item d-flex align-center w-100">
          <div class="item-container">
            <ad_form_icons
              :icon="'word_count'"
              class="item-container--icon"
              />
            <p class="item-container--text mb-0">Word Count</p>
          </div>
          <div
            v-if="!isEditing.includes('editableInput-wordCount')"
            class="mb-0 item-input"
            :class="{
              'hover': isHovered.includes('editableInput-wordCount'),
              'item-input--empty': !assignmentForm.wordCount,
              'item-input--fullfield': assignmentForm.wordCount,
            }"
            style="position: relative;"
            @mouseenter="isHoveredOn('editableInput-wordCount')"
            @mouseleave="isHoveredOff('editableInput-wordCount')"
            @click="startEditing('editableInput-wordCount')"
          >
            <p class="item-input--p mb-0">
              {{ assignmentForm.wordCount ? assignmentForm.wordCount : '0' }}
            </p>
            <span
              @click.stop.prevent="updateAssignmentData({ field: 'wordCount', data: '' })"
              class="item-input--clear"
              v-if="isHovered.includes('editableInput-wordCount') && assignmentForm.wordCount"
            >
              <pmdashboard_table_icons
                :icon="'pmdashboard_clear_text_field'"
                class="pmdashboard__clear-text d-block"
              />
            </span>
          </div>
          <input
            v-else
            type="text"
            ref="editableInput-wordCount"
            v-model="wordCountField"
            @blur="stopEditing('editableInput-wordCount')"
            @keydown.enter="stopEditing('editableInput-wordCount')"
            class="hover item-input--empty item-input--field bradius-4"
          />
        </div>

        <!-- Character Count -->
        <div class="addFormMainTab__data--left--item d-flex align-center w-100">
          <div class="item-container">
            <ad_form_icons
              :icon="'word_count'"
              class="item-container--icon"
              />
            <p class="item-container--text mb-0">Character Count</p>
          </div>
          <div
            v-if="!isEditing.includes('editableInput-characterCount')"
            class="mb-0 item-input"
            :class="{
              'hover': isHovered.includes('editableInput-characterCount'),
              'item-input--empty': !assignmentForm.characterCount,
              'item-input--fullfield': assignmentForm.characterCount,
            }"
            style="position: relative;"
            @mouseenter="isHoveredOn('editableInput-characterCount')"
            @mouseleave="isHoveredOff('editableInput-characterCount')"
            @click="startEditing('editableInput-characterCount')"
          >
            <p class="item-input--p mb-0">
              {{ assignmentForm.characterCount ? assignmentForm.characterCount : '0' }}
            </p>
            <span
              @click.stop.prevent="updateAssignmentData({ field: 'characterCount', data: '' })"
              class="item-input--clear"
              v-if="isHovered.includes('editableInput-characterCount') && assignmentForm.characterCount"
            >
              <pmdashboard_table_icons
                :icon="'pmdashboard_clear_text_field'"
                class="pmdashboard__clear-text d-block"
              />
            </span>
          </div>
          <input
            v-else
            type="text"
            ref="editableInput-characterCount"
            v-model="characterCountField"
            @blur="stopEditing('editableInput-characterCount')"
            @keydown.enter="stopEditing('editableInput-characterCount')"
            class="hover item-input--empty item-input--field bradius-4"
          />
        </div>
      </div>
      </div>
    <div class="addFormMainTab__steps">
      <div class="addFormMainTab__steps--header">
        <h3 class="addFormMainTab__steps--header--title">Deadlines & Assignees</h3>
        <div class="addFormMainTab__steps--header--timeconverter">
          <div class="steps__timeconverter--dropdown" 
            style="width: 158px; margin-right: 5px;">
            <div class="dropdown-wrapper" :class="{'background-color': toggleTimeValue === 'MyTime'}">
              <span class="dropdown-text" @click="updateTimeValue('MyTime')">{{ myTime.label }}</span>
              <button class="dropdown-arrow" id="myTimePicker" @click="toggleMyTimeDropdown"></button>
              <ul v-if="dropdownMyTimeOpen" class="dropdown-menu">
                <li v-for="(option, index) in timeZoneOptions" 
                    :key="index"
                    @click="selectMyOption(option)">
                  {{ option.label }}
                </li>
              </ul>
            </div>
          </div>
          <div class="steps__timeconverter--dropdown" style="width: 168px;">
            <div class="dropdown-wrapper" :class="{'background-color': toggleTimeValue === 'ClientTime'}">
              <span class="dropdown-text" @click="updateTimeValue('ClientTime')">{{ clientTime.label }}</span>
              <button class="dropdown-arrow" id="clientTimePicker" @click="toggleClentDropdown"></button>
              <ul v-if="dropdownClientTimeOpen" class="dropdown-menu">
                <li v-for="(option, index) in clientTimeZoneOptions" 
                    :key="index" 
                    @click="selectClientOption(option)">
                  {{ option.label }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="addFormMainTab__steps--content">
        <div class="steps__fields">
          <div class="steps__fields--left">

            <!-- Request Date and Time -->
            <div class="addFormMainTab__data--left--item d-flex align-center w-100">
              <div class="item-container" style="width: 220px;">
                <pmdashboard_table_icons
                  :icon="'pmdashboard_request_date'"
                  class="item-container--icon"
                  />
                <p class="item-container--text mb-0">
                  Request Date/Time
                </p>
              </div>
              <div class="mb-0 item-input">
                <div class="item-input--p mb-0">
                  <v-menu
                    v-model="requestDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <p
                        class="mb-0 bradius-4 bg-2-state"
                        :class="{
                          'item-input--empty': !(assignmentForm.requestDate && assignmentForm.requestTime),
                          'item-input--fullfield': (assignmentForm.requestDate && assignmentForm.requestTime),
                        }"
                        @mouseover="isHoveredOn('editableInput-requestDate')"
                        @mouseout="isHoveredOff('editableInput-requestDate')"
                        @click="showRequestDateMenu"
                      >
                        {{ assignmentForm.requestDate && assignmentForm.requestTime ? formattedRequestDateTime : 'Empty' }}
                      </p>
                    </template>
                    
                    <CustomDateTimePicker 
                      :preparedDate="assignmentForm.requestDate" 
                      :preparedTime="assignmentForm.requestTime"
                      @onDateSelected="onRequestDateSelected"
                      @onTimeSelected="onRequestTimeSelected($event)"/>
                    
                  </v-menu>
                </div>
              </div>
            </div>

            <!-- Delivery Date and Time -->
            <div class="addFormMainTab__data--left--item d-flex align-center w-100">
              <div class="item-container" style="width: 220px;">
                <pmdashboard_table_icons
                  :icon="'pmdashboard_deliveryDate'"
                  class="item-container--icon"
                  />
                <p class="item-container--text mb-0">
                  Delivery Date/Time
                </p>
              </div>
              <div class="mb-0 item-input">
                <div class="item-input--p mb-0">
                  <v-menu
                    v-model="deliveryDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <p
                        class="mb-0 bradius-4 bg-2-state"
                        :class="{
                          'item-input--empty': !(assignmentForm.deliveryDate && assignmentForm.deliveryTime),
                          'item-input--fullfield': (assignmentForm.deliveryDate && assignmentForm.deliveryTime),
                        }"
                        @mouseover="isHoveredOn('editableInput-deliveryDate')"
                        @mouseout="isHoveredOff('editableInput-deliveryDate')"
                        @click="showDeliveryDateMenu"
                      >
                        {{ assignmentForm.deliveryDate && assignmentForm.deliveryTime ? formattedDeliveryDateTime : 'Empty' }}
                      </p>
                    </template>
                    
                    <CustomDateTimePicker 
                      :preparedDate="assignmentForm.deliveryDate" 
                      :preparedTime="assignmentForm.deliveryTime"
                      @onDateSelected="onDeliveryDateSelected"
                      @onTimeSelected="onDeliveryTimeSelected($event)"/>
                    
                  </v-menu>
                </div>
              </div>
            </div>
          </div>
          <div class="steps__fields--right">

            <!-- Override Staff Availability -->
            <div class="addFormMainTab__data--left--item d-flex align-center w-100">
              <div class="item-container" style="width: 220px;">
                <ad_form_icons
                  :icon="'clock_fast'"
                  class="item-container--icon"
                  />
                <p class="item-container--text mb-0" style="min-width: 180px;">
                  Override Staff Availability
                </p>
              </div>
              <div class="mb-0 item-input--checkbox">
                <v-checkbox
                  class="mt-0 pt-0"
                  style="margin-left: 8px;"
                  hide-details="true"
                  v-model="overrideStaffAvailabilityField"
                ></v-checkbox>
              </div>
            </div>

            <!-- Override Due Dates -->
            <div class="addFormMainTab__data--left--item d-flex align-center w-100">
              <div class="item-container" style="width: 220px;">
                <ad_form_icons
                  :icon="'calendar_close'"
                  class="item-container--icon"
                  />
                <p class="item-container--text mb-0" style="min-width: 180px;">
                  Override Due Dates
                </p>
              </div>
              <div class="mb-0 item-input--checkbox">
                <v-checkbox
                  class="mt-0 pt-0"
                  style="margin-left: 8px;"
                  hide-details="true"
                  v-model="overrideDueDatesField"
                ></v-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="steps__table">
          <div class="steps__table--left">
            <div class="steps__table--left--header">
              <p class="header--text">Step & Assignee</p>
            </div>
            <div class="steps__table--left--row">
              <v-autocomplete
                :item-text="fullName"
                :items="relatedWriters"
                return-object
                v-model="writer"
                label="Primary"
                hide-details
                flat
              ></v-autocomplete>
            </div>
            <div class="steps__table--left--row">
              <v-autocomplete
                :item-text="fullName"
                :items="relatedEditors"
                return-object
                v-model="editor"
                label="Secondary"
                hide-details
                flat
              ></v-autocomplete>
            </div>
            <div class="steps__table--left--row">
              <v-autocomplete
                :item-text="fullName"
                :items="reviewers"
                return-object
                v-model="reviewer"
                label="QC"
                hide-details
                flat
              ></v-autocomplete>
            </div>
          </div>
          <div class="steps__table--left">
            <div class="steps__table--left--header">
              <p class="header--text">Due Date / Time</p>
            </div>
            <div class="steps__table--center--row">
              <v-menu
                v-model="primaryDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <p
                    class="steps__table--center--row--text"
                    @click="primaryDateMenu = true"
                  >
                    {{ 
                      assignmentForm.schedule.primaryDueDate && assignmentForm.schedule.primaryDueTime ? 
                        formattedAssigneeDateTime(assignmentForm.schedule.primaryDueDate, assignmentForm.schedule.primaryDueTime) : 
                        'Select Date' 
                    }}
                  </p>
                </template>
                
                <CustomDateTimePicker 
                  :preparedDate="assignmentForm.schedule.primaryDueDate" 
                  :preparedTime="assignmentForm.schedule.primaryDueTime"
                  @onDateSelected="onPrimaryDateSelected"
                  @onTimeSelected="onPrimaryTimeSelected($event)"/>
                
              </v-menu>
            </div>
            <div class="steps__table--center--row">
              <v-menu
                v-model="secondaryDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <p
                    class="steps__table--center--row--text"
                    @click="secondaryDateMenu = true"
                  >
                    {{ 
                      assignmentForm.schedule.secondaryDueDate && assignmentForm.schedule.secondaryDueTime ? 
                        formattedAssigneeDateTime(assignmentForm.schedule.secondaryDueDate, assignmentForm.schedule.secondaryDueTime) : 
                        'Select Date' 
                    }}
                  </p>
                </template>
                
                <CustomDateTimePicker 
                  :preparedDate="assignmentForm.schedule.secondaryDueDate" 
                  :preparedTime="assignmentForm.schedule.secondaryDueTime"
                  @onDateSelected="onSecondaryDateSelected"
                  @onTimeSelected="onSecondaryTimeSelected($event)"/>
                
              </v-menu>
            </div>
            <div class="steps__table--center--row">
              <v-menu
                v-model="qcDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <p
                    class="steps__table--center--row--text"
                    @click="qcDateMenu = true"
                  >
                    {{ 
                      assignmentForm.schedule.qcDueDate && assignmentForm.schedule.qcDueTime ? 
                        formattedAssigneeDateTime(assignmentForm.schedule.qcDueDate, assignmentForm.schedule.qcDueTime) : 
                        'Select Date' 
                    }}
                  </p>
                </template>
                
                <CustomDateTimePicker 
                  :preparedDate="assignmentForm.schedule.qcDueDate" 
                  :preparedTime="assignmentForm.schedule.qcDueTime"
                  @onDateSelected="onQCDateSelected"
                  @onTimeSelected="onQCTimeSelected($event)"/>
                
              </v-menu>
            </div>
          </div>
          <div class="steps__table--left">
            <div class="steps__table--left--header">
              <p class="header--text">Accepted</p>
            </div>
            <div class="steps__table--center--row">
              <p
                class="steps__table--center--row--text">
                -
              </p>
            </div>
            <div class="steps__table--center--row">
              <p
                class="steps__table--center--row--text">
                -
              </p>
            </div>
            <div class="steps__table--center--row">
              <p
                class="steps__table--center--row--text">
                -
              </p>
            </div>
          </div>
        </div>
        <!-- Timeline over the assignment's real milestones: Request Date, the
        Primary / Secondary / QC deadlines that are set, and the Delivery Date. -->
        <div class="steps__timeline">
          <p class="steps__timeline--header">{{ timelineHeader }}</p>

          <div class="steps__timeline--body" v-if="timelineMilestones.length > 1">
            <div class="timeline-line"></div>
            <div class="timeline-line timeline-line--active" :style="{ width: activeWidth }"></div>
            <div class="timeline-steps">
              <div
                v-for="step in timelineMilestones"
                :key="step.key"
                class="timeline-step"
                :class="{ active: isStepActive(step) }"
              >
                <v-tooltip bottom color="#0F62FE">
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on"
                      class="circle"></span>
                  </template>
                  <span class="tooltip-text">{{ step.label }}: {{ step.formatted }}</span>
                </v-tooltip>
              </div>
            </div>
          </div>
          <p v-else class="steps__timeline--empty mb-0">
            Set the Request Date and the Delivery Date to see the timeline.
          </p>
        </div>
      </div>  
    </div>
    <div class="addFormMainTab__workTypes">
      <div class="addFormMainTab__workTypes--header">
        <h3 class="addFormMainTab__workTypes--header--title">Work Types & Work Quantity</h3>
        <div class="addFormMainTab__workTypes--header--pricingModel">
          <div class="workTypes-pricingModel--dropdown" 
            style="width: 417px; margin-right: 5px;">
            <div class="dropdown-wrapper">
              <p class="dropdown-text" @click="togglePricingModelDropdown">
                <span class="dropdown-text--label">Pricing Model:</span> {{ assignmentForm.pricingModel ? assignmentForm.pricingModel : 'Select Pricing Model' }}
              </p>
              <button class="dropdown-arrow" id="pricingModel" @click="togglePricingModelDropdown"></button>
              <ul v-if="dropdownPricingModelOpen" class="dropdown-menu">
                <li v-for="(option, index) in pricingModelList" 
                    :key="index"
                    @click="selectPricingModel(option)">
                  {{ option }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="addFormMainTab__workTypes--content">
        <div class="addFormMainTab__workTypes--content--table">
          <div class="workTypes-table--header">
            <div class="workTypes-table--header--item">Work Type</div>
            <div class="workTypes-table--header--item">Quantity</div>
            <div class="workTypes-table--header--item">Primary Rate</div>
            <div class="workTypes-table--header--item">Secondary Rate</div>
            <div class="workTypes-table--header--item">Client Rate</div>
            <div class="workTypes-table--header--item">Status</div>
            <div class="workTypes-table--header--item"></div>
          </div>

          <div
            class="workTypes-table--row"
            v-for="(workType, i) in sortedWorkTypes"
            :key="i"
          >
            <!-- Work Type -->
            <div class="workTypes-table--row--item">
              <span
                class="workTypes-table--worktype-name"
                @click="
                  checkPrice(
                    workType.customerPriceList?.workTypeCategory,
                    workType.customerPriceList?.workTypeName
                  )
                "
              >
                {{ workType.customerPriceList?.workTypeName }}
              </span>
            </div>

            <!-- Quantity -->
            <div class="workTypes-table--row--item">
              {{ groupedTooltipHours.length ? convertToDecimal() : workType.quantity }}
              <v-icon
                v-if="groupedTooltipHours.length && groupedTooltipHours[0]?.status !== 'Not Submitted'"
                @click="showTooltip = !showTooltip"
                size="20"
                style="margin-left: 3.5px;"
              >
                mdi-information
              </v-icon>
              <v-tooltip
                v-if="groupedTooltipHours.length"
                v-model="showTooltip"
                top
                color="white"
                content-class="custom-tooltip"
              >
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on"></span>
                </template>
                <div
                  v-for="(hourItem, idx) in groupedTooltipHours"
                  :key="idx"
                  :class="{ 'mb-2': idx !== groupedTooltipHours.length - 1 }"
                >
                  <p class="mb-0 tooltip-date">{{ hourItem.dateForInfo }} - {{ hourItem.hours }}h {{ hourItem.minutes }}m</p>
                  <p class="mb-0 tooltip-note" v-if="hourItem.note">{{ hourItem.note }}</p>
                </div>
              </v-tooltip>
            </div>

            <!-- Primary Rate -->
            <div class="workTypes-table--row--item">
              {{ `$${(workType.customerPriceList?.primaryPriceCard ?? 0).toFixed(2)}` }}
            </div>

            <!-- Secondary Rate -->
            <div class="workTypes-table--row--item">
              {{
                workType.customerPriceList?.secondaryPriceCard !== null
                  ? `$${(workType.customerPriceList?.secondaryPriceCard ?? 0).toFixed(2)}`
                  : "-"
              }}
            </div>

            <!-- Client Rate -->
            <div class="workTypes-table--row--item">
              {{
                workType.customerPriceList?.clientPriceCard !== null
                  ? `$${(workType.customerPriceList?.clientPriceCard ?? 0).toFixed(2)}`
                  : "-"
              }}
            </div>

            <!-- Status -->
            <div class="workTypes-table--row--item">
              <v-chip
                v-if="groupedTooltipHours.length"
                :class="{ 'text-white': groupedTooltipHours[0]?.status === 'Approved' }"
                class="px-3 d-flex align-center justify-center"
                small
                :color="groupedTooltipHours[0]?.status === 'Approved' ? '#1976D2' : ''"
              >
                {{ groupedTooltipHours[0]?.status }}
              </v-chip>
            </div>

            <!-- Actions -->
            <div class="workTypes-table--row--item">
              <v-menu
                v-if="
                  (assignmentForm?.status === 'Pending Hours' || assignmentForm?.status === 'Reviewing Hours')
                    && groupedTooltipHours.length
                    && groupedTooltipHours[0]?.status !== 'Approved'
                    && groupedTooltipHours[0]?.status !== 'Not Submitted'
                "
                offset-y
                top
                transition="slide-y-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn text icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list class="wtMenuList">
                  <v-list-item
                    v-if="user.user.userRole !== 'STAFF' && groupedTooltipHours[0]?.status !== 'Approved'"
                    class="wtMenuList__item"
                    @click="showReviewModal"
                  >
                    <v-list-item-title>Review Hours</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="groupedTooltipHours[0]?.status !== 'Approved' && assignmentForm?.primary?.id === user.user.id"
                    class="wtMenuList__item"
                    @click="editTimeResubmission"
                  >
                    <v-list-item-title>Change Hours</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>

          <!-- TOTAL -->
          <div
            class="workTypes-table--row workTypes-table--row--total"
            v-if="sortedWorkTypes.length"
          >
            <div class="workTypes-table--row--item">TOTAL</div>
            <div class="workTypes-table--row--item"></div>
            <div class="workTypes-table--row--item">
              {{ `$${Number(assignmentForm.pricing.primaryTotal ?? 0).toFixed(2)}` }}
            </div>
            <div class="workTypes-table--row--item">
              {{
                assignmentForm.pricing.secondaryTotal != null
                  ? `$${Number(assignmentForm.pricing.secondaryTotal).toFixed(2)}`
                  : "-"
              }}
            </div>
            <div class="workTypes-table--row--item">
              {{
                assignmentForm.pricing.clientTotal != null
                  ? `$${Number(assignmentForm.pricing.clientTotal).toFixed(2)}`
                  : "-"
              }}
            </div>
            <div class="workTypes-table--row--item"></div>
            <div class="workTypes-table--row--item"></div>
          </div>
        </div>
        <div class="addFormMainTab__workTypes--content--actions">
          <v-btn
            class="mr-2"
            outlined
            color="#1976D2"
            @click="setLogWorkTypeModalOpen(true)"
          >
            Add Work Type
          </v-btn>
          <v-btn
            outlined
            color="#1976D2"
            @click="openHoursSubmission"
          >
            Log Work Time
          </v-btn>
        </div>
      </div>
    </div>

    <v-dialog
      v-model="hoursSubmissionModalOpen"
      max-width="795"
      persistent
    >
      <ADHoursSubmission
      @assignment-dashboard-table-refresh="$emit('assignment-dashboard-table-refresh')"/>
    </v-dialog>

    <v-dialog
      v-model="logWorkTypeModalOpen"
      max-width="466"
      persistent
    >
      <ADLogWorkType />
    </v-dialog>

  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import { alphabetColors, managersDesiredColors, ROUTES, DOMAIN, fileLocationDropdownOptions } from "@/utils/constants.js";
import { getOneProject } from "@/utils/newDbUtils.js";
import { parseFormDateTime, officeWallClockNow } from "@/utils/assignmentFormUtils.js";
import CustomDateTimePicker from "@/components/ui/CustomDateTimePicker.vue";
import ADHoursSubmission from "@/components/AssignmentDashboard/ADHoursSubmission.vue";
import ADLogWorkType from "@/components/AssignmentDashboard/ADLogWorkType.vue";
import pmdashboard_table_icons from "@/assets/icons/pmdashboard_table_icons.vue";
import ad_filters_icons from '@/assets/icons/ad_filters_icons.vue';
import ad_form_icons from '@/assets/icons/ad_form_icons.vue';

export default {
  name: 'ADFormMainTab',

  components: {
    ad_filters_icons,
    pmdashboard_table_icons,
    ad_form_icons,
    CustomDateTimePicker,
    ADHoursSubmission,
    ADLogWorkType
  },

  props: {
    projectsList: {
      type: Array,
      required: true,
    },
    staffList: {
      type: Array,
      required: true
    },
    staffHours: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      showTooltip: false,
      // Drives the timeline's "now" marker. Office wall clock, so it compares
      // like with like against the stored deadlines. Ticked on an interval so the
      // countdown in the header stays honest while the form sits open.
      nowTs: officeWallClockNow(),
      nowTimer: null,
      dropdownPricingModelOpen: false,
      pricingModelList: ['FC Localization: Per Word', 'FC Localization: Per Unit', 'FC Localization: Combined (Per Word + Per Unit)', 'FC Copywriting', 'Non FC'],
      temporaryUserStorage: null,
      isHovered: [],
      isEditing: [],
      fileLocationOptions: fileLocationDropdownOptions,
      priorityMenu: false,
      keywordMenu: false,
      mediaTypeMenu: false,
      fileLocationMenu: false,
      projectManagerMenu: false,
      relatedProjectMenu: false,
      clientRequesterMenu: false,
      purchaseOrderMenu: false,
      payPeriodMenu: false,
      statusOptions: {
        initiation: [
          { text: 'Requested', color: '#7BC4C480', icon: 'mdi-circle' },
        ],
        inProgress: [
          { text: 'Assigned', color: '#8CA9C3', icon: 'mdi-circle' },
          { text: 'Primary Complete', color: '#9FB8F8', icon: 'mdi-circle' },
          { text: 'Secondary Complete', color: '#567DDF', icon: 'mdi-circle' },
          { text: 'QC Complete', color: '#3F599B', icon: 'mdi-circle' },
        ],
        blocked: [
          { text: 'Pending Hours', color: '#F1DE99', icon: 'mdi-circle' },
          { text: 'Reviewing Hours', color: '#EFCD56', icon: 'mdi-circle' },
          { text: 'On Hold', color: '#EBCF6D', icon: 'mdi-circle' },
        ],
        preDelivery: [
          { text: 'Ready for Delivery', color: '#C29DF4', icon: 'mdi-circle' },
        ],
        finished: [
          { text: 'Delivered', color: '#70D9A4', icon: 'mdi-circle' },
          { text: 'Canceled', color: '#FFA1A6', icon: 'mdi-circle' },
        ],
      },
      myTime: {
        label: `My (EDT-04:00)`,
        value: "-04:00",
      },
      clientTime: {
        label: `Client (EDT-04:00)`,
        value: "-04:00",
      },
      defaultTime: "-04:00",
      ifTimeZoneWasTriggered: false,
      toggleTimeValue: 'ClientTime',
      dropdownClientTimeOpen: false,
      dropdownMyTimeOpen: false,
      showDatePicker: false,
      showTimePicker: false,
      requestDateMenu: false,
      deliveryTimePicker: false,
      deliveryDateMenu: false,
      deliveryDatePicker: false,
      primaryDateMenu: false,
      qcDateMenu: false,
      secondaryDateMenu: false,
      timeZones: [
        "PST-08:00",
        "PDT-07:00",
        "CST-06:00",
        "EST-05:00",
        "EDT-04:00",
        "GMT+00:00",
        "CET+01:00",
        "CEST+02:00",
        "EET+02:00",
        "EEST+03:00",
        "GST+04:00",
        "HKT+08:00",
        "KST+09:00",
      ],
      assignees: [
        {type: 'Primary', value: 'Anita Xu', primaryDueDate: '2026-12-13', primaryDueTime: '09:48 AM', accepted: false},
        {type: 'Secondary', value: 'John Doe', secondaryDueDate: '2026-12-19', secondaryDueTime: '09:48 AM', accepted: false},
        {type: 'QC', value: 'Jane Doe', qcDueDate: '2026-12-25', qcDueTime: '09:48 AM', accepted: false},
      ]
    };
  },

  computed: {
    ...mapGetters("assignment", [
      "mediaTypeOptions",
      "keywordOptions",
      "assignmentForm",
      "relatedWriters",
      "relatedEditors",
      "reviewers",
      "hoursSubmissionModalOpen",
      "logWorkTypeModalOpen"
    ]),
    ...mapGetters("auth", ["isAdmin", "isManager", "user"]),
    groupedTooltipHours() {
      const grouped = [];
      this.staffHours.forEach(item => {
        const date = new Date(item.date[0], item.date[1] - 1, item.date[2]);
        const newDate = date.toLocaleDateString('en-US', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
        });
        grouped.push({
          dateForInfo: newDate,
          date: date,
          hours: item.workedHours,
          minutes: item.workedMinutes,
          note: item.note,
          status: item.status === "APPROVED"
            ? "Approved"
            : item.status === "PENDING"
              ? "Pending"
              : item.status === "REVIEWING_HOURS"
                ? "Reviewing Hours"
              : item.status
        })
      })
      if (this.staffHours.length === 0 && this.assignmentForm.status === "Pending Hours") {
        grouped.push({
          dateForInfo: "",
          date: "",
          hours: "",
          minutes: "",
          note: "",
          status: "Not Submitted"
        })
      }

      return grouped;
    },
    // The assignment's milestones in chronological order. Secondary and QC are
    // optional, so only the deadlines that are actually set get a dot.
    timelineMilestones() {
      const form = this.assignmentForm;
      const schedule = form.schedule || {};
      return [
        { key: 'request', label: 'Request', date: form.requestDate, time: form.requestTime },
        { key: 'primary', label: 'Primary Due', date: schedule.primaryDueDate, time: schedule.primaryDueTime },
        { key: 'secondary', label: 'Secondary Due', date: schedule.secondaryDueDate, time: schedule.secondaryDueTime },
        { key: 'qc', label: 'QC Due', date: schedule.qcDueDate, time: schedule.qcDueTime },
        { key: 'delivery', label: 'Delivery', date: form.deliveryDate, time: form.deliveryTime },
      ]
        .map((step) => {
          const at = parseFormDateTime(step.date, step.time);
          return at
            ? { ...step, at, formatted: this.formatDateTime(at) }
            : null;
        })
        .filter(Boolean)
        // It is a time axis, so it has to read left to right even when the
        // deadlines are out of order (validation is what flags that).
        .sort((a, b) => a.at.getTime() - b.at.getTime());
    },
    // "15d 7h to deliver" against the real Delivery Date, or how far past it we
    // are once it has gone by.
    timelineHeader() {
      const delivery = parseFormDateTime(
        this.assignmentForm.deliveryDate,
        this.assignmentForm.deliveryTime
      );
      if (!delivery) return 'No delivery date set';

      const diff = delivery.getTime() - this.nowTs;
      const totalHours = Math.floor(Math.abs(diff) / 3600000);
      const days = Math.floor(totalHours / 24);
      const hours = totalHours % 24;
      const span = days ? `${days}d ${hours}h` : `${hours}h`;

      if (diff < 0) return `${span} past delivery`;
      return `${span} to deliver`;
    },
    // The dots are evenly spaced (justify-content: space-between), so progress is
    // measured in step space rather than raw elapsed time — otherwise the bar
    // never lines up with the dot it is supposed to be reaching.
    activeWidth() {
      const steps = this.timelineMilestones;
      if (steps.length < 2) return '0%';

      const times = steps.map((step) => step.at.getTime());
      const now = this.nowTs;
      if (now <= times[0]) return '0%';
      if (now >= times[times.length - 1]) return '100%';

      let index = 0;
      for (let i = 0; i < times.length - 1; i++) {
        if (now >= times[i]) index = i;
      }
      const segment = times[index + 1] - times[index];
      const withinSegment = segment > 0 ? (now - times[index]) / segment : 0;
      const progress = (index + withinSegment) / (times.length - 1);

      return `${Math.min(Math.max(progress, 0), 1) * 100}%`;
    },
    timeZoneOptions() {
      const options = [];
      for (let i = 0; i < this.timeZones.length; i++) {
        const offset = this.timeZones[i].slice(-6);
        options.push({
          label: `My (${this.timeZones[i]})`,
          value: offset,
        });
      }
      return options;
    },
    clientTimeZoneOptions() {
      const options = [];
      for (let i = 0; i < this.timeZones.length; i++) {
        const offset = this.timeZones[i].slice(-6);
        options.push({
          label: `Client (${this.timeZones[i]})`,
          value: offset,
        });
      }
      return options;
    },
    clientRequesterList() {
      if (this.assignmentForm.relatedProject && this.assignmentForm.relatedProject.clientRequesters?.length) {
        const clients = this.assignmentForm.relatedProject.clientRequesters;
        clients.forEach((el) => {
          el.name = `${el.user.firstName} ${el.user.lastName}`
        })
        return clients.sort((a, b) => (a.user?.firstName > b.user?.firstName ? 1 : -1));
      } else {
        return [];
      }
    },
    statusColor() {
      const allOptions = [
        ...this.statusOptions.initiation,
        ...this.statusOptions.inProgress,
        ...this.statusOptions.blocked,
        ...this.statusOptions.preDelivery,
        ...this.statusOptions.finished,
      ];
      const statusOption = allOptions.find(
        (option) => option.text === this.assignmentForm.status
      );
      return statusOption ? statusOption.color : '#000';
    },
    pmList() {
      return this.staffList
        .filter(el => el.user.userRole === "MANAGER")
        .map(el => {
          const firstName = el.user.firstName || "";
          const lastName = el.user.lastName || "";

          const initials =
            (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();

          const name = `${firstName} ${lastName}`.trim();

          return {
            ...el,
            initials,
            name
          };
        });
    },
    formattedRequestDateTime() {
      const { requestDate, requestTime } = this.assignmentForm;
      if (!requestDate || !requestTime) {
        return "Empty";
      }
      const date = this.parseDateTime(requestDate, requestTime);
      if (isNaN(date)) return "Empty";
      return this.formatDateTime(date);
    },
    formattedDeliveryDateTime() {
      const { deliveryDate, deliveryTime } = this.assignmentForm;
      if (!deliveryDate || !deliveryTime) {
        return "Empty";
      }
      const date = this.parseDateTime(deliveryDate, deliveryTime);
      if (isNaN(date)) return "Empty";
      return this.formatDateTime(date);
    },
    taskNameField: {
      get() {
        return this.assignmentForm.taskName;
      },
      set(value) {
        this.updateAssignmentData({ field: "taskName", data: value });
      },
    },
    payPeriodField: {
      get() {
        return this.assignmentForm.payPeriod;
      },
      set(value) {
        this.updateAssignmentData({ field: "payPeriod", data: value });
      },
    },
    projectManagerField: {
      get() {
        return this.assignmentForm.projectManager;
      },
      set(value) {
        this.updateAssignmentData({ field: "projectManager", data: value });
      },
    },
    assignmentDetailField: {
      get() {
        return this.assignmentForm.assignmentDetail;
      },
      set(value) {
        this.updateAssignmentData({ field: "assignmentDetail", data: value });
      },
    },
    emailSubjectLineField: {
      get() {
        return this.assignmentForm.emailSubjectLine;
      },
      set(value) {
        this.updateAssignmentData({ field: "emailSubjectLine", data: value });
      },
    },
    genreField: {
      get() {
        return this.assignmentForm.genre;
      },
      set(value) {
        this.updateAssignmentData({ field: "genre", data: value });
      },
    },
    wordCountField: {
      get() {
        return this.assignmentForm.wordCount;
      },
      set(value) {
        this.updateAssignmentData({ field: "wordCount", data: value });
      },
    },
    characterCountField: {
      get() {
        return this.assignmentForm.characterCount;
      },
      set(value) {
        this.updateAssignmentData({ field: "characterCount", data: value });
      },
    },
    overrideStaffAvailabilityField: {
      get() {
        return this.assignmentForm.overrideStaffAvailability;
      },
      set(value) {
        this.updateAssignmentData({ field: "overrideStaffAvailability", data: value });
      },
    },
    overrideDueDatesField: {
      get() {
        return this.assignmentForm.overrideDueDates;
      },
      set(value) {
        this.updateAssignmentData({ field: "overrideDueDates", data: value });
      },
    },
    writer: {
      get() {
        return this.assignmentForm.primary;
      },
      set(value) {
        this.updateAssignmentData({ field: "primary", data: value });
      },
    },
    editor: {
      get() {
        return this.assignmentForm.secondary;
      },
      set(value) {
        this.updateAssignmentData({ field: "secondary", data: value });
      },
    },
    reviewer: {
      get() {
        return this.assignmentForm.qc;
      },
      set(value) {
        this.updateAssignmentData({ field: "qc", data: value });
      },
    },
    sortedWorkTypes() {
      const workTypes = this.assignmentForm.pricing?.workTypes ?? [];
      if (
        this.assignmentForm.relatedProject?.name === "iTunes FC" &&
        this.assignmentForm.requestType === "Copywriting"
      ) {
        const getIndex = (wt) => {
          if (
            wt === "CWR_500-60-1100" ||
            wt === "CWR_2500-00-3800" ||
            wt === "CWR_2500-00-4500" ||
            wt === "CWR_3500-00-4500" ||
            wt === "CWR_1000-00-00"
          )
            return 0;
          else if (wt === "CWR_1000-120-1500") return 1;
          else if (wt === "CWR_1500-180-2800") return 2;
          else if (
            wt === "CWR_1000-380-3800" ||
            wt === "CWR_1500-380-3800" ||
            wt === "CWR_2500-300-3800" ||
            wt === "CWR_2000-500-3800"
          )
            return 3;
          else if (wt === "CWR_5000-500-7000") return 4;
          else if (wt === "CWR_300-100-500" || wt === "CWR_500-00-500")
            return 5;
          else return 6;
        };
        return workTypes
          .map((el) => ({
            ...el,
            index: getIndex(el.customerPriceList?.workTypeName),
          }))
          .sort((a, b) => a.index - b.index);
      }
      return workTypes;
    }
  },

  methods: {
    ...mapActions("assignment", [
      "updateAssignmentData",
      "getStaffByGeo",
      "setHoursSubmissionModalOpen",
      "setLogWorkTypeModalOpen",
      "setEditingWorkType",
      "setStaffHoursData",
      "openReviewModal"
    ]),
    // Anchored to UTC to match formatDateTime, which renders with
    // timeZone: "UTC". Building the date locally and reading it back as UTC (what
    // this used to do) shifted every displayed time by the viewer's offset.
    // Returns an Invalid Date when unparseable, so the isNaN() checks on the
    // callers still hold.
    parseDateTime(dateStr, timeStr) {
      return parseFormDateTime(dateStr, timeStr) ?? new Date(NaN);
    },
    editWorkType(workType, index) {
      this.setEditingWorkType({
        ...workType,
        index
      });

      this.setLogWorkTypeModalOpen(true);
    },
    formattedAssigneeDateTime(date, time) {
      if (!date || !time) {
        return "No values";
      }
      const dateTime = this.parseDateTime(date, time);
      if (isNaN(dateTime)) return "No values";
      return this.formatDateTime(dateTime);
    },
    fullName(item) {
      return `${item?.user?.firstName} ${item?.user?.lastName}`;
    },
    formatDateTime(date) {
      const datePart = date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        timeZone: 'UTC',
      });

      const timePart = date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
        timeZone: 'UTC',
      });

      return `${datePart} (${timePart})`;
    },
    showRequestDateMenu() {
      this.showTimePicker = false;
      this.requestDateMenu = true;
      this.showDatePicker = true;
    },
    onRequestDateSelected(date) {
      console.log("onRequestDateSelected", date);
      this.updateAssignmentData({ field: "requestDate", data: date });
      this.showDatePicker = false;
      this.showTimePicker = true;
    },
    onRequestTimeSelected(timeAmPm) {
      console.log("onRequestTimeSelected", timeAmPm);
      const [time, modifier] = timeAmPm.split(' ');
      let [hours, minutes] = time.split(':');

      if (modifier === 'PM' && hours !== '12') {
        hours = parseInt(hours, 10) + 12;
      }
      if (modifier === 'AM' && hours === '12') {
        hours = '00';
      }
      hours = hours.toString().padStart(2, '0');
      this.updateAssignmentData({ field: "requestTime", data: `${hours}:${minutes}:00` });
      this.ifTimeZoneWasTriggered = false;
      this.stopEditing("requestDate");
    },
    showDeliveryDateMenu() {
      this.deliveryTimePicker = false;
      this.deliveryDateMenu = true;
      this.deliveryDatePicker = true;
    },
    onDeliveryDateSelected(date) {
      this.updateAssignmentData({ field: "deliveryDate", data: date });
      this.deliveryDatePicker = false;
      this.deliveryTimePicker = true;
    },
    onDeliveryTimeSelected(timeAmPm) {
      const [time, modifier] = timeAmPm.split(' ');
      let [hours, minutes] = time.split(':');

      if (modifier === 'PM' && hours !== '12') {
        hours = parseInt(hours, 10) + 12;
      }
      if (modifier === 'AM' && hours === '12') {
        hours = '00';
      }
      hours = hours.toString().padStart(2, '0');
      this.updateAssignmentData({ field: "deliveryTime", data: `${hours}:${minutes}:00` });
      this.ifTimeZoneWasTriggered = false;
      this.stopEditing("deliveryDate");
    },
    onPrimaryDateSelected(date) {
      this.updateAssignmentData({ field: "schedule", data: {...this.assignmentForm.schedule, primaryDueDate: date} });
    },
    onPrimaryTimeSelected(timeAmPm) {
      const [time, modifier] = timeAmPm.split(' ');
      let [hours, minutes] = time.split(':');

      if (modifier === 'PM' && hours !== '12') {
        hours = parseInt(hours, 10) + 12;
      }
      if (modifier === 'AM' && hours === '12') {
        hours = '00';
      }
      hours = hours.toString().padStart(2, '0');
      this.updateAssignmentData({ field: "schedule", data: {...this.assignmentForm.schedule, primaryDueTime: `${hours}:${minutes}:00`} });
    },
    onSecondaryDateSelected(date) {
      this.updateAssignmentData({ field: "schedule", data: {...this.assignmentForm.schedule, secondaryDueDate: date} });
    },
    onSecondaryTimeSelected(timeAmPm) {
      const [time, modifier] = timeAmPm.split(' ');
      let [hours, minutes] = time.split(':');

      if (modifier === 'PM' && hours !== '12') {
        hours = parseInt(hours, 10) + 12;
      }
      if (modifier === 'AM' && hours === '12') {
        hours = '00';
      }
      hours = hours.toString().padStart(2, '0');
      this.updateAssignmentData({ field: "schedule", data: {...this.assignmentForm.schedule, secondaryDueTime: `${hours}:${minutes}:00`} });
    },
    onQCDateSelected(date) {
      this.updateAssignmentData({ field: "schedule", data: {...this.assignmentForm.schedule, qcDueDate: date} });
    },
    onQCTimeSelected(timeAmPm) {
      const [time, modifier] = timeAmPm.split(' ');
      let [hours, minutes] = time.split(':');

      if (modifier === 'PM' && hours !== '12') {
        hours = parseInt(hours, 10) + 12;
      }
      if (modifier === 'AM' && hours === '12') {
        hours = '00';
      }
      hours = hours.toString().padStart(2, '0');
      this.updateAssignmentData({ field: "schedule", data: {...this.assignmentForm.schedule, qcDueTime: `${hours}:${minutes}:00`} });
    },
    selectClientOption(option) {
      this.ifTimeZoneWasTriggered = true;
      this.defaultTime = this.toggleTimeValue === 'MyTime' ? this.myTime.value : this.clientTime.value;
      this.clientTime = option;
      this.updateDeliveryTime(`${this.deliveryDate}, ${this.deliveryTime}`, this.defaultTime, this.toggleTimeValue === 'MyTime' ? this.myTime.value : this.clientTime.value);
      this.updateRequestTime(`${this.requestDate}, ${this.requestTime}`, this.defaultTime, this.toggleTimeValue === 'MyTime' ? this.myTime.value : this.clientTime.value);
      this.dropdownClientTimeOpen = false;
    },
    selectMyOption(option) {
      this.ifTimeZoneWasTriggered = true;
      this.defaultTime = this.toggleTimeValue === 'MyTime' ? this.myTime.value : this.clientTime.value;
      this.myTime = option;
      this.updateDeliveryTime(`${this.deliveryDate}, ${this.deliveryTime}`, this.defaultTime, this.toggleTimeValue === 'MyTime' ? this.myTime.value : this.clientTime.value);
      this.updateRequestTime(`${this.requestDate}, ${this.requestTime}`, this.defaultTime, this.toggleTimeValue === 'MyTime' ? this.myTime.value : this.clientTime.value);
      this.dropdownMyTimeOpen = false;
    },
    updateTimeValue(value) {
      if (this.toggleTimeValue === value) return;
      this.toggleTimeValue = value;
      this.defaultTime = value === 'MyTime' ? this.clientTime.value : this.myTime.value;
      this.updateDeliveryTime(`${this.deliveryDate}, ${this.deliveryTime}`, this.defaultTime, this.toggleTimeValue === 'MyTime' ? this.myTime.value : this.clientTime.value);
      this.updateRequestTime(`${this.requestDate}, ${this.requestTime}`, this.defaultTime, this.toggleTimeValue === 'MyTime' ? this.myTime.value : this.clientTime.value);
    },
    updateRequestTime(dateTime, oldOffset, newOffset) {
      const [date, time] = dateTime.split(',').map(s => s.trim());
      const [year, month, day] = date.split('-').map(Number);
      const [hours, minutes] = time.split(':').map(Number);
      const utcDate = new Date(Date.UTC(year, month - 1, day, hours, minutes));
      const oldOffsetMinutes = parseInt(oldOffset) * 60;
      const newOffsetMinutes = parseInt(newOffset) * 60;
      const offsetDifference = newOffsetMinutes - oldOffsetMinutes;
      utcDate.setMinutes(utcDate.getMinutes() + offsetDifference);
      const newYear = utcDate.getUTCFullYear();
      const newMonth = String(utcDate.getUTCMonth() + 1).padStart(2, '0');
      const newDay = String(utcDate.getUTCDate()).padStart(2, '0');
      const newHours = String(utcDate.getUTCHours()).padStart(2, '0');
      const newMinutes = String(utcDate.getUTCMinutes()).padStart(2, '0');
      this.requestTime = `${newHours}:${newMinutes}`;
      this.requestDate = `${newYear}-${newMonth}-${newDay}`
    },
    updateDeliveryTime(dateTime, oldOffset, newOffset) {
      const [date, time] = dateTime.split(',').map(s => s.trim());
      if (date == 'null' || time == 'null') return;
      const [year, month, day] = date.split('-').map(Number);
      const [hours, minutes] = time.split(':').map(Number);
      const utcDate = new Date(Date.UTC(year, month - 1, day, hours, minutes));
      const oldOffsetMinutes = parseInt(oldOffset) * 60;
      const newOffsetMinutes = parseInt(newOffset) * 60;
      const offsetDifference = newOffsetMinutes - oldOffsetMinutes;
      utcDate.setMinutes(utcDate.getMinutes() + offsetDifference);
      const newYear = utcDate.getUTCFullYear();
      const newMonth = String(utcDate.getUTCMonth() + 1).padStart(2, '0');
      const newDay = String(utcDate.getUTCDate()).padStart(2, '0');
      const newHours = String(utcDate.getUTCHours()).padStart(2, '0');
      const newMinutes = String(utcDate.getUTCMinutes()).padStart(2, '0');
      this.deliveryTime = `${newHours}:${newMinutes}`;
      this.deliveryDate = `${newYear}-${newMonth}-${newDay}`;
    },
    toggleClentDropdown() {
      this.dropdownClientTimeOpen = !this.dropdownClientTimeOpen;
    },
    toggleMyTimeDropdown() {
      this.dropdownMyTimeOpen = !this.dropdownMyTimeOpen;
    },
    togglePricingModelDropdown() {
      this.dropdownPricingModelOpen = !this.dropdownPricingModelOpen;
    },
    setMediaType(item) {
      this.updateAssignmentData({ field: "mediaType", data: item });
      this.mediaTypeMenu = false;
    },
    setKeyword(item) {
      this.updateAssignmentData({ field: "keyword", data: item });
      this.keywordMenu = false;
    },
    handleFileLocationUpdate(item) {
      this.updateAssignmentData({ field: "fileLocation", data: item.label });
      this.stopEditing("fileLocation");
      this.fileLocationMenu = false;
    },
    startEditing(item) {
      this.isEditing.push(item);
      this.$nextTick(() => {
        this.$refs[item].focus();
      });
    },
    handlePriorityUpdate(item) {
      this.updateAssignmentData({ field: "priority", data: item });
    },
    isHoveredOn(item) {
      if (!this.isHovered.includes(item)) {
        this.isHovered.push(item);
      }
    },
    isHoveredOff(item) {
      if (this.isHovered.includes(item)) {
        this.isHovered = this.isHovered.filter((i) => i !== item);
      }
    },
    stopEditing(item) {
      if (
        item != "relatedProject" 
        || item != "clientRequester"
        || item != "deliveryDate"
        || item != "requestDate"
      ) {
        this.isEditing = this.isEditing.filter((i) => i !== item);
        this.isHovered = this.isHovered.filter((i) => i !== item);
      }
    },
    relaunchRelatedProject() {
      if (this.assignmentForm.relatedProject && this.assignmentForm.relatedProject.name !== "Empty") {
        this.temporaryUserStorage = _.cloneDeep(this.assignmentForm.relatedProject);
      }
      this.relatedProjectMenu = true;
      this.updateAssignmentData({ field: "relatedProject", data: {
        name: "Empty"
      } });
    },
    relaunchPMMenu() {
      if (this.assignmentForm.projectManager && this.assignmentForm.projectManager.id) {
        this.temporaryUserStorage = _.cloneDeep(this.assignmentForm.projectManager);
      }
      this.updateAssignmentData({ field: "projectManager", data: null });
      this.projectManagerMenu = true;
    },
    relaunchClientRequester() {
      if (this.assignmentForm.clientRequester && this.assignmentForm.clientRequester.user.firstName !== "Empty") {
        this.temporaryUserStorage = _.cloneDeep(this.assignmentForm.clientRequester);
      }
      this.clientRequesterMenu = true;
      this.updateAssignmentData({ field: "clientRequester", data: {
        user: {
          firstName: "Empty",
          lastName: "",
        }
      }})
    },
    relaunchPurchaseOrder() {
      if (this.assignmentForm.purchaseOrder) {
        this.temporaryUserStorage = _.cloneDeep(this.assignmentForm.purchaseOrder);
      }
      if (this.assignmentForm.relatedProject && this.assignmentForm.relatedProject.name !== "Empty") {
        this.purchaseOrderMenu = true;
        this.updateAssignmentData({ field: "purchaseOrder", data: null });
      }
    },
    relaunchFileLocation() {
      if (this.assignmentForm.fileLocation) {
        this.temporaryUserStorage = _.cloneDeep(this.assignmentForm.fileLocation);
      }
      this.updateAssignmentData({ field: "fileLocation", data: null });
      this.fileLocationMenu = true;
    },
    relaunchMediaType() {
      if (this.assignmentForm.mediaType) {
        this.temporaryUserStorage = _.cloneDeep(this.assignmentForm.mediaType);
      }
      this.updateAssignmentData({ field: "mediaType", data: null });
      this.mediaTypeMenu = true;
    },
    relaunchKeyword() {
      if (this.assignmentForm.keyword) {
        this.temporaryUserStorage = _.cloneDeep(this.assignmentForm.keyword);
      }
      this.updateAssignmentData({ field: "keyword", data: null });
      this.keywordMenu = true;
    },
    clearFileLocation() {
      this.updateAssignmentData({ field: "fileLocation", data: null });
    },
    async handleRelatedProjectUpdate(item) {
      const response = await getOneProject(item.id);
      this.updateAssignmentData({ field: 'relatedProject', data: response.data });
      this.updateAssignmentData({ field: 'clientRequester', data: {
        user: {
          firstName: "Empty",
          lastName: "",
        }
      } });
      if (this.assignmentForm.geo && this.assignmentForm.relatedProject && this.assignmentForm.relatedProject.name !== 'Empty') this.getStaffByGeo({selectedGeo: this.assignmentForm.geo});
      this.relatedProjectMenu = false;
      this.stopEditing("relatedProject");
    },
    onRelatedProjectFocus(e) {
      this.$refs.relatedProjectAutocomplete.isMenuActive = true;
    },
    onCloientRequesterFocus(e) {
      this.$refs.clientRequesterAutocomplete.isMenuActive = true;
    },
    onPurchaseOrderFocus(e) {
      this.$refs.purchaseOrderAutocomplete.isMenuActive = true;
    },
    onFileLocationFocus(e) {
      this.$refs.fileLocationAutocomplete.isMenuActive = true;
    },
    onMediaTypeFocus(e) {
      this.$refs.mediaTypeAutocomplete.isMenuActive = true;
    },
    onKeywordFocus(e) {
      this.$refs.keywordAutocomplete.isMenuActive = true;
    },
    onPMFocus(e) {
      this.$refs.pmAutocomplete.isMenuActive = true;
    },
    // setHoursSubmissionModalOpen only commits `data.assignmentInfo`, so the key
    // has to match or the dialog opens against a stale record.
    openHoursSubmission() {
      this.setHoursSubmissionModalOpen({
        status: true,
        assignmentInfo: this.assignmentForm,
      });
    },
    // Reopening a filled dropdown clears the value first (see the relaunch*
    // helpers) so the autocomplete starts empty. If the user then clicks away
    // without picking anything the previous value has to come back — otherwise
    // just opening a dropdown and dismissing it wipes the field.
    handleClickOutside(event) {
      const dismiss = (field, menuKey, isEmpty) => {
        if (event.target.id === `editableInput-${field}`) return;
        if (!this[menuKey]) return;
        this[menuKey] = false;
        if (isEmpty(this.assignmentForm[field]) && this.temporaryUserStorage) {
          this.updateAssignmentData({
            field,
            data: _.cloneDeep(this.temporaryUserStorage),
          });
        }
        // The slot is shared by every dropdown, so it must not outlive the menu
        // that filled it.
        this.temporaryUserStorage = null;
      };

      // relatedProject / clientRequester use sentinel objects rather than null
      // for "nothing selected".
      dismiss("relatedProject", "relatedProjectMenu", (v) => v?.name === "Empty");
      dismiss(
        "clientRequester",
        "clientRequesterMenu",
        (v) => v?.user?.firstName === "Empty"
      );
      dismiss("purchaseOrder", "purchaseOrderMenu", (v) => !v);
      dismiss("projectManager", "projectManagerMenu", (v) => !v);
      dismiss("fileLocation", "fileLocationMenu", (v) => !v);
      dismiss("mediaType", "mediaTypeMenu", (v) => !v);
      dismiss("keyword", "keywordMenu", (v) => !v);

      if (event.target.id != "editableInput-priority") {
        this.priorityMenu = false;
      }
    },
    clearRelatedProject() {
      this.updateAssignmentData({ field: 'relatedProject', data: {
        name: 'Empty'
      } });
      this.updateAssignmentData({ field: 'clientRequester', data: {
        user: {
          firstName: "Empty",
          lastName: "",
        }
        } });
    },
    clearClientRequester() {
      this.updateAssignmentData({ field: 'clientRequester', data: {
        user: {
          firstName: "Empty",
          lastName: "",
        }
      }});
    },
    clearPOField() {
      this.updateAssignmentData({ field: 'purchaseOrder', data: null });
    },
    handleClientRequesterUpdate(item) {
      this.updateAssignmentData({ field: 'clientRequester', data: item });
      this.stopEditing("clientRequester");
      this.clientRequesterMenu = false;
    },
    handleClientPOUpdate(item) {
      this.updateAssignmentData({ field: "purchaseOrder", data: item });
      this.stopEditing("purchaseOrder");
      this.purchaseOrderMenu = false;
    },
    formattedPayPeriod(dateString) {
      const [year, month] = dateString.split("-");
      const date = new Date(year, month - 1, 1);

      if (isNaN(date)) {
        console.error('Invalid Date:', dateString);
        return 'Invalid Date';
      }

      return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short' });
    },
    handlePMUpdate(item) {
      this.updateAssignmentData({ field: "projectManager", data: item });
      this.projectManagerMenu = false;
    },
    onPayPeriodPicker() {
      this.payPeriodMenu = false;
    },
    updateStatus(item) {
      this.updateAssignmentData({ field: "status", data: item.text });
    },
    toggleIsBilled() {
      this.updateAssignmentData({ field: "isBilled", data: !this.assignmentForm.isBilled });
    },
    getColorForInitials(initials, name) {
      if (name) {
        const colorItem = managersDesiredColors.find(el => el.name === name);
        if (colorItem) {
          return colorItem.color
        } else return initials && initials[1] && alphabetColors.find((color) => color.character === initials[1])?.color || "#9747FF";
      }
      return initials && initials[1] && alphabetColors.find((color) => color.character === initials[1])?.color || "#9747FF";
    },
    isStepActive(step) {
      return step.at.getTime() <= this.nowTs;
    },
    formatDate(date) {
      const d = new Date(date)
      return d.toLocaleDateString('en-US')
    },
    selectPricingModel(item) {
      this.updateAssignmentData({ field: "pricingModel", data: item });
      this.togglePricingModelDropdown();
    },
    showReviewModal() {
      this.setHoursSubmissionModalOpen({ status: true, assignmentInfo: this.assignmentForm });
      this.setStaffHoursData(this.staffHours);
      this.openReviewModal(true);
    },
    editTimeResubmission() {
      this.setHoursSubmissionModalOpen({ status: true, assignmentInfo: this.assignmentForm });
      this.setStaffHoursData(this.staffHours);
    },
    checkPrice(workTypeCategory, workTypeName) {
      if (this.isAdmin)
        window.open(
          `${DOMAIN}/${ROUTES.customerPriceList}?WorkTypeCategory=${workTypeCategory}&Search=${workTypeName}`,
          "_blank"
        );
    },
    convertToDecimal() {
      let hours = 0;
      let minutes = 0;
      this.groupedTooltipHours.forEach(item => {
        hours += +item.hours || 0;
        minutes += +item.minutes || 0;
      })
      return hours + minutes / 60;
    },
  },
  mounted() {
    // Keeps the timeline's progress bar and "time to deliver" current without
    // making the whole tab re-render more often than once a minute.
    this.nowTimer = setInterval(() => {
      this.nowTs = officeWallClockNow();
    }, 60000);
    document.addEventListener('click', this.handleClickOutside);
    let relatedProjectInput = this.$refs.relatedProjectAutocomplete.$refs.input;
    relatedProjectInput.addEventListener('focus', this.onRelatedProjectFocus, true);
    let clientRequesterInput = this.$refs.clientRequesterAutocomplete.$refs.input;
    clientRequesterInput.addEventListener('focus', this.onCloientRequesterFocus, true);
    let purchaseOrderInput = this.$refs.purchaseOrderAutocomplete.$refs.input;
    purchaseOrderInput.addEventListener('focus', this.onPurchaseOrderFocus, true);
    let pmInput = this.$refs.pmAutocomplete.$refs.input;
    pmInput.addEventListener('focus', this.onPMFocus, true);
    let fileLocationInput = this.$refs.fileLocationAutocomplete.$refs.input;
    fileLocationInput.addEventListener('focus', this.onFileLocationFocus, true);
    let mediaTypeInput = this.$refs.mediaTypeAutocomplete.$refs.input;
    mediaTypeInput.addEventListener('focus', this.onMediaTypeFocus, true);
    let keywordInput = this.$refs.keywordAutocomplete.$refs.input;
    keywordInput.addEventListener('focus', this.onKeywordFocus, true);
  },
  beforeDestroy() {
    if (this.nowTimer) clearInterval(this.nowTimer);
    document.removeEventListener('click', this.handleClickOutside);
    let relatedProjectInput = this.$refs.relatedProjectAutocomplete.$refs.input;
    relatedProjectInput.removeEventListener('focus', this.onRelatedProjectFocus, true);
    let clientRequesterInput = this.$refs.clientRequesterAutocomplete.$refs.input;
    clientRequesterInput.removeEventListener('focus', this.onCloientRequesterFocus, true);
    let purchaseOrderInput = this.$refs.purchaseOrderAutocomplete.$refs.input;
    purchaseOrderInput.removeEventListener('focus', this.onPurchaseOrderFocus, true);
    let pmInput = this.$refs.pmAutocomplete.$refs.input;
    pmInput.removeEventListener('focus', this.onPMFocus, true);
    let fileLocationInput = this.$refs.fileLocationAutocomplete.$refs.input;
    fileLocationInput.removeEventListener('focus', this.onFileLocationFocus, true);
    let mediaTypeInput = this.$refs.mediaTypeAutocomplete.$refs.input;
    mediaTypeInput.removeEventListener('focus', this.onMediaTypeFocus, true);
    let keywordInput = this.$refs.keywordAutocomplete.$refs.input;
    keywordInput.removeEventListener('focus', this.onKeywordFocus, true);
  }
};
</script>

<style lang="scss">
  .addFormMainTab {
    width: 100%;
    &__data {
      width: 100%;
      display: flex;
      gap: 15px;
      &--left {
        &--item {
          height: 40px;
          width: 300px;
          display: flex;
          align-items: center;
          & .item-container {
            display: flex;
            align-items: center;
            width: 170px;
            &--icon {
              width: 18px;
              height: 18px;
              color: #656F7D;
              margin-right: 10px;
              &--left {
                margin: 0  2px 0 10px;
              }
            }
            &--text {
              font-family: 'Roboto', sans-serif;
              font-weight: 400;
              font-size: 16px;
              color: #656F7D;
            }
          }
          & .item-input {
            width: 300px;
            min-width: 0;
            padding-right: 25px !important;
            position: relative;
            &--empty {
              color: #B4B4B4;
              padding: 2px 5px;
              height: 40px;
              display: flex;
              align-items: center;
              width: 300px;
            }
            &--fullfield {
              color: #000000 !important;
              padding: 2px 5px;
              font-weight: 400;
              height: 40px;
              display: flex;
              align-items: center;
              width: 300px;
            }
            &--field {
              outline: none;
              color: #000000;
              width: 300px;
            }
            &--p {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            &--clear {
              width:16px;
              height: 16px;
              padding: 4px;
              border-radius: 2px;
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              z-index: 9000 !important;
              position: absolute !important;
              top: 50%;
              transform: translateY(-45%);
              right: 10px;
              &:hover {
                background-color: #DEDEDE;
                cursor: pointer;
              }
            }
            &--checkbox {
              width: 100%;
              height: 40px;
              margin-left: 5px;
              background-color: #ffffff;
              display: flex;
              align-items: center;
            }
          }
          & .item-input-p0 {
            padding-right: 0 !important;
            padding-left: 0 !important;
          }
        }
      }
      &--right {
        min-width: 470px;
      }
    }
    &__status {
      &--chip {
        font-family: 'Roboto', sans-serif;
        font-weight: 500;
        font-size: 16px;
        line-height: 18px;
        color: #FFFFFF;
        cursor: pointer;
      }
    }
    &__steps {
      display: flex;
      flex-direction: column;
      margin-top: 36px;
      &--header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;
        &--title {
          color: #0000008A;
          font-family: 'Roboto', sans-serif;
          font-weight: 500;
          font-size: 14px;
          text-transform: uppercase;
          display: flex;
          align-items: center;
        }
        &--timeconverter {
          display: flex;
          align-items: center;
          & .steps__timeconverter--dropdown {
            display: inline-block;
            position: relative;
            width: 180px;
            border-radius: 5px;
            .dropdown-wrapper {
              display: flex;
              align-items: center;
              justify-content: space-between;
              border-radius: 5px;
              padding: 4px;
              cursor: pointer;
            }
            .dropdown-text {
              flex-grow: 1;
              font-size: 16px;
              font-weight: 400;
              color: #656F7D !important;
              font-family: 'Roboto', sans-serif !important;
            }
            .dropdown-arrow {
              background-color: transparent;
              border: none;
              cursor: pointer;
              background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>');
              background-repeat: no-repeat;
              background-position: center;
              background-size: 12px 12px;
              width: 20px;
              height: 20px;
            }
            .dropdown-menu {
              position: absolute;
              top: 100%;
              left: 0;
              right: 0;
              margin: 0;
              padding: 0;
              list-style: none;
              background-color: #fff;
              border: 1px solid #ccc;
              border-radius: 4px;
              max-height: 200px;
              min-width: 200px;
              overflow-y: auto;
              z-index: 1000;
            }
            .dropdown-menu li {
              padding: 10px;
              cursor: pointer;
            }
            .dropdown-menu li:hover {
              background-color: #f0f0f0;
            }
            .background-color {
              background-color: #D9D9D9 !important;
            }
          }
        }
      }
      &--content {
        padding: 15px 10px;
        border-radius: 6px;
        background-color: #F5F5F5;
        & .steps__fields {
          margin-top: 15px;
          display: flex;
          &--left {
            display: flex;
            flex-direction: column;
            gap: 15px;
            width: 480px;
          }
          &--right {
            display: flex;
            flex-direction: column;
            gap: 15px;
            width: 480px;
          }
        }
        & .steps__table {
          margin-top: 15px;
          display: flex;
          justify-content: space-between;
          gap: 5px;
          width: 100%;
          &--left {
            width: 33%;
            &--header {
              display: flex;
              align-items: center;
              justify-content: space-between;
              height: 40px;
              background-color: #fff;
              border-bottom: 1px solid #0000001F;
              padding: 10px 12px;
              & .header--text {
                color: #6C737A;
                font-family: 'Roboto', sans-serif;
                font-weight: 700;
                font-size: 14px;
                margin: 0;
              }
            }
            &--row {
              background-color: #fff;
              padding-bottom: 7px;
              padding-left: 12px;
            }
          }
          &--center {
            &--row {
              background-color: #fff;
              padding-left: 12px;
              min-height: 50px;
              margin-top: 4px;
              display: flex;
              align-items: center;
              justify-content: flex-start;
              cursor: pointer;
              &--text {
                width: 100%;
                height: 100%;
                margin: 0;
                color: #000000DE;
                font-family: 'Roboto', sans-serif;
                font-size: 16px;
              }
            }
          }
        }
        & .steps__timeline {
          width: 100%;
          background-color: #fff;
          border-radius: 8px;
          padding: 16px;
          margin-top: 15px;
          &--header {
            color: #0072C3;
            font-family: 'Lato', 'Roboto', sans-serif;
            font-weight: 700;
            font-size: 16px;
            margin: 0 0 4px 0;
          }
          &--empty {
            font-family: 'Lato', 'Roboto', sans-serif;
            font-size: 14px;
            color: #757575;
            padding: 15px 0;
          }
          &--body {
            position: relative;
            padding: 15px 0;
            .timeline-line {
              position: absolute;
              top: 4px;
              width: 100%;
              height: 22px;
              background: #E0E0E0;
              border-radius: 64px;
            }
            .timeline-line--active {
              position: absolute;
              top: 4px;
              background: #1976d2;
              z-index: 1;
            }
            .timeline-steps {
              position: absolute;
              top: 4px;
              display: flex;
              justify-content: space-between;
              z-index: 2;
              width: 100%;
              .timeline-step {
                display: flex;
                flex-direction: column;
                align-items: center;
                .tooltip-text {
                  font-family: 'Lato', 'Roboto', sans-serif;
                  font-weight: 700;
                  font-size: 14px;
                }
                .circle {
                  width: 19px;
                  height: 19px;
                  background-color: #BCD2FF;
                  border-radius: 50%;
                  margin-top: auto;
                  margin-bottom: auto;
                  cursor: pointer;
                }
                .date {
                  margin-top: 8px;
                  font-size: 12px;
                  white-space: nowrap;
                }
                &:first-child {
                  align-items: flex-start;
                  margin: 1.5px 0 1.5px 1.5px;
                }
                &:last-child {
                  align-items: flex-end;
                  margin: 1.5px 1.5px 0 1.5px;
                }
              }
              .timeline-step.active {
                .circle {
                  background-color: #FF8F8F;
                }
              }
            }
          }
        }
      }
    }
    &__workTypes {
      display: flex;
      flex-direction: column;
      margin-top: 36px;
      &--header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;
        &--title {
          color: #0000008A;
          font-family: 'Roboto', sans-serif;
          font-weight: 500;
          font-size: 14px;
          text-transform: uppercase;
          display: flex;
          align-items: center;
        }
        &--pricingModel {
          .workTypes-pricingModel--dropdown {
            display: inline-block;
            position: relative;
            width: 180px;
            border-radius: 5px;
            .dropdown-wrapper {
              display: flex;
              align-items: center;
              justify-content: space-between;
              border-top-left-radius: 4px;
              border-top-right-radius: 4px;
              padding: 4px 12px;
              cursor: pointer;
              background-color: #0000000F;
              border-bottom: 1px solid #0000006B;
            }
            .dropdown-text {
              color: #000000DE !important;
              font-family: 'Roboto', sans-serif !important;
              font-weight: 400;
              font-size: 14px;
              margin: 0;
            }
            .dropdown-text--label {
              flex-grow: 1;
              font-size: 14px;
              font-weight: 400;
              color: #656F7D !important;
              font-family: 'Roboto', sans-serif !important;
            }
            .dropdown-arrow {
              background-color: transparent;
              border: none;
              cursor: pointer;
              background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>');
              background-repeat: no-repeat;
              background-position: center;
              background-size: 12px 12px;
              width: 20px;
              height: 20px;
            }
            .dropdown-menu {
              position: absolute;
              top: 100%;
              left: 0;
              right: 0;
              margin: 0;
              padding: 0;
              list-style: none;
              background-color: #fff;
              border: 1px solid #ccc;
              border-radius: 4px;
              max-height: 200px;
              min-width: 200px;
              overflow-y: auto;
              z-index: 1000;
            }
            .dropdown-menu li {
              padding: 10px;
              cursor: pointer;
            }
            .dropdown-menu li:hover {
              background-color: #f0f0f0;
            }
            .background-color {
              background-color: #D9D9D9 !important;
            }
          }
        }
      }
      &--content {
        padding: 15px 10px;
        border-radius: 6px;
        background-color: #F5F5F5;
        &--table {
          display: flex;
          flex-direction: column;
          .workTypes-table--header {
            display: flex;
            width: 100%;
            list-style-type: none;
            height: 48px;
            padding: 0 16px;
            background-color: #FFFFFF;
            color: #6C737A;
            font-family: 'Roboto', sans-serif;
            font-weight: 700;
            font-size: 14px;
            margin-bottom: 1px;
            &--item {
              flex-shrink: 0;
              display: flex;
              align-items: center;
              justify-content: flex-start;
            }
            &--item:nth-child(1) { width: 22%; }
            &--item:nth-child(2) { width: 13%; }
            &--item:nth-child(3) { width: 15%; }
            &--item:nth-child(4) { width: 17%; }
            &--item:nth-child(5) { width: 15%; }
            &--item:nth-child(6) { width: 13%; }
            &--item:nth-child(7) { width: 5%; justify-content: flex-end; }
          }
          .workTypes-table--row {
            display: flex;
            width: 100%;
            list-style-type: none;
            height: 48px;
            padding: 0 16px;
            background-color: #FFFFFF;
            color: #000000DE;
            font-family: 'Roboto', sans-serif;
            font-weight: 400;
            font-size: 14px;
            margin-bottom: 1px;
            &--item {
              flex-shrink: 0;
              display: flex;
              align-items: center;
              justify-content: flex-start;
            }
            &--item:nth-child(1) { width: 22%; }
            &--item:nth-child(2) { width: 13%; }
            &--item:nth-child(3) { width: 15%; }
            &--item:nth-child(4) { width: 17%; }
            &--item:nth-child(5) { width: 15%; }
            &--item:nth-child(6) { width: 13%; }
            &--item:nth-child(7) { width: 5%; justify-content: flex-end; }
          }
          .workTypes-table--row--total {
            font-weight: 700;
          }
          .workTypes-table--worktype-name {
            text-decoration: underline;
            cursor: pointer;
          }
          .v-chip.v-size--small {
            min-width: 90px;
            justify-content: center;
          }
        }
        &--actions {
          margin-top: 15px;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
    .v-autocomplete .v-input__slot::before,
    .v-autocomplete .v-input__slot::after {
      border-bottom: none !important;
      content: none !important;
    }
  }

  .bradius-4 {
    border-radius: 4px !important;
  }

  .hover {
    background-color: #F2F2F2;
  }

  .bg-2-state {
    background-color: #FFFFFF;
    cursor: pointer;
  }

  .additional-hover {
    &:hover {
      cursor: pointer;
    }
  }

  .dropdown-initials-chip {
    border-radius: 50% !important;
    height: 40px !important;
  }

  .user-status-name {
    display: flex;
    align-items: center;
    &-initials {
      min-width: 36px;
      height: 36px;
      font-size: 16px;
      font-weight: 400;
      color: #fff;
      border-radius: 50%;
      background-color: #9747FF;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &-text {
      color: #000;
      font-size: 16px !important;
      font-weight: 400 !important;
      font-family: 'Roboto', sans-serif !important;
      & a {
        color: #0000EE !important;
      }
    }
  }

  .text-white {
    color: #fff !important;
  }

  .wtMenuList {
    &__item {
      &:hover {
        cursor: pointer;
      }
    }
  }

  .custom-tooltip {
    box-shadow: 0px 0px 6px 6px #00000014;
    max-width: 267px;
  }

  .tooltip-date {
    font-family: Roboto;
    font-weight: 500;
    font-size: 14px;
    color: #000;
  }

  .tooltip-note {
    font-family: Roboto;
    font-weight: 300;
    font-size: 12px;
    color: #000;
  }
</style>